import {map, take, takeUntil} from 'rxjs/operators';
import {Preference} from '../../../../avisDePub/preferences-avis-de-pub/model/preference';
import {PreferenceType} from '../../../models/enum/preferenceType';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import {MatMenuTrigger} from '@angular/material/menu';
import {BehaviorSubject, Observable, Subject} from 'rxjs/';
import {environment} from '../../../../../../environments/environment';
import {StepperBuilderService} from '../../../../avisDePub/creer/services/stepper.builder.service';
import {AutoCompleteService, AutoCompleteType} from '../../../services/auto-complete.service';
import {LogService} from '../../../services/log.service';
import {ValidatorService, existsInReferenceListValidator} from '../../../services/validator.service';
import {FormInputErrorTools} from '../form-input-error/utils/form-input-error.tools';
import {Field} from '../../../../formulaires/eforms/model/field';
import {ErrorWafConverterService} from '../../../services/error-waf-converter.service';
import {FormInputFactory} from './form.input.factory';
import {CanNavigateInStepperService} from '../../../services/can-navigate-in-stepper.service';
import {TranslateService} from '@ngx-translate/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {OtherOptionComponent} from '../../../modals/other-option/other-option.component';
import {InformationComponent} from '../../../modals/information/information.component';
import {EformsSubjectService} from '../../../../formulaires/eforms/services/eforms-subject.service';
import cloneDeep from 'lodash.clonedeep';
import {AvisDataTransferService} from '../../../services/avis-data-transfer.service';
import {EformConditionsService} from '../../../../formulaires/eforms/services/eform-conditions.service';
import {EformDataService} from '../../../../formulaires/eforms/services/eform-data.service';
import {EformInfoService} from '../../../../formulaires/eforms/services/eform-info.service';
import {EformDynamicListService} from '../../../../formulaires/eforms/services/eform-dynamic-list.service';
import {orgFields} from '../../../models/enum/orgFields';
import {EformDuplicableEntityService} from '../../../../formulaires/eforms/services/eform-duplicable-entity.service';
import {DuplicableElementsIdSchemeEnum} from '../../../../formulaires/eforms/enum/duplicable-elements-id-scheme.enum';
import {FormInput} from './form.input';
import {IndexTrackerService} from '../../../../formulaires/eforms/services/index-tracker.service';
import {DuplicableElementSubSectionIdEnum} from '../../../../formulaires/eforms/enum/duplicable-element-sub-section-id.enum';
import {ConditionsV2EformsEnum} from '../../../../../models/enums/conditions-v2-eforms.enum';
import {EformConditionsV2Service} from '../../../../formulaires/eforms/services/eform-conditions-v2.service';
import {NutsCountryFilterService} from '../../../../formulaires/eforms/services/nuts-country-filter.service';
import {ConditionGroup, ConditionOperator, SimpleCondition} from '../../../../formulaires/eforms/model/condition';
import {ConditionType} from '../../../../formulaires/eforms/enum/condition-type.enum';
import {EformsFieldCounterService} from '../../../../formulaires/eforms/services/eforms-field-counter.service';
import {EformSharedFieldsService} from '../../../../formulaires/eforms/services/eform-shared-fields.service';
import {EmptyValueHelper} from '../../../helpers/EmptyValueHelper';

@Component({
  selector: 'app-form-input',
  templateUrl: './form-input.component.html',
  styleUrls: ['./form-input.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FormInputComponent implements OnInit, OnDestroy, AfterViewInit {
  public separatorKeysCodes: number[] = [ENTER, COMMA];
  public idFromName: string;
  public selectedOptions: any = [];
  public filteredOptions: Observable<any[]>;
  public timestamp: string;
  public preferenceList: Observable<any[]>;
  public fieldTextType = false;
  public isPrefActivated = false;
  localformGroup: any = new FormGroup({});
  public pathElements;
  public isEform: boolean;
  public selectedCodes: string[] = [];
  @Input() field: Field = {} as Field;
  @Input() noticeValue: any;
  @Input() type: string;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() infoBulle: string;
  @Input() name: string;
  @Input() value: any;
  @Input() disabled: boolean;
  @Input() hidden: boolean;
  @Input() parentForm: FormGroup;
  @Input() moreClass: string;
  @Input() rule: string;
  @Input() radios: any[] = null;
  @Input() isChecked: string;
  @Input() options: Array<string>;
  @Input() optionsWithCode: Array<any>;
  @Input() autoCompleteType: AutoCompleteType;
  @Input() autoCompleteTypeIndex: number;
  @Input() checkboxDestination: string;
  @Input() errorMessage: string;
  @Input() maxLength: number;
  @Input() typeSelect: string;
  @Input() preferenceType: PreferenceType;
  @Input() donneePreference: any;
  @Output() preferenceSelected = new EventEmitter<Preference>();
  @Input() repeatablePath: string;
  @Input() repeatablePathWithIndex: string;
  @Input() prefixId: string;
  @Input() subSectionId: string;
  @Input() groupOrSectionId: string;
  @Input() isEformTable = false;
  @Input() modalValue = null;
  @Input() arrayLength = 0;
  @Input() lastElementArray = null;
  @Input() isRawValue = false;
  @Input() modalOpen = false;
  @Input() fieldLastArray = null;
  @Output() newField = new EventEmitter();
  @Output() deleteField = new EventEmitter();
  @Input() sharedPath = undefined;
  @Input() isCPV: boolean;
  @Input() index: string;
  @Input() getRepeatablePathForDuplicableElementFromParent: () => string;
  @Input() getRepeatablePathWithIndexForInput: (Field) => string;
  @Input() buttonOtherOption: boolean = false;
  buttonDupliquerLabel = 'eform-editable.button-dupliquer';
  buttonSupprimerLabel = 'eform-editable.button-supprimer';
  @ViewChild('chipsInput') chipsInput: ElementRef<HTMLInputElement>;
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  private LOG: LogService = new LogService(FormInputComponent);
  private DATE_FORMAT = 'yyyy-MM-dd';
  private DATETIME_FORMAT = 'yyyy-MM-dd HH:mm';
  private TIME_FORMAT = 'HH:mm:ss';
  private CHECK_BOX = 'checkbox';
  private CHECK_BOX_STRING = 'string';
  private CHECK_BOX_OBJECT = 'object';
  private CHECK_BOX_LIST = 'list';
  private CHECK_BOX_BOOLEAN = 'boolean';
  private CHIPS = 'chips';
  private AUTO_COMPLETE = 'autocomplete';
  private AUTO_COMPLETE_WITH_STAR = 'autocompleteWithStar';
  private RADIO = 'radio';
  private DATE = 'date';
  private DATETIME = 'datetime';
  private NUMBER = 'number';
  private PERCENTAGE = 'percentage';
  private MONEY = 'money';
  private TIME_STAMP = 'timestamp';
  private deletedControlName = new Array<string>();
  private onError = false;
  private optionsWithCodeForModal: Array<any>;
  private unsubscribeIdSchemeList$ = new Subject<void>();
  private unsubscribe$ = new Subject<void>();
  /** Flag par instance de composant pour détecter la transition visible→caché sur les champs partagés */
  private _sharedFieldWasForbidden: boolean | undefined = undefined;
  /** Flag par instance pour le préremplissage de BT-15-Lot — réinitialisé à chaque transition caché→visible */
  private _prefillDocumentUrlApplied: boolean = false;
  private repeatablePathForDuplicableElement: BehaviorSubject<string> = new BehaviorSubject(null);
  private subConditions = [];
  private currentCheckedValue = null;
  /** Liste complète des codes NUTS, avant filtrage par pays */
  private allNutsOptions: Array<any> = [];
  /** Identifiant du champ pays associé, null si le champ n'est pas un code NUTS */
  private nutsCountryFieldId: string | null = null;
  /** Dernier code pays connu ; undefined tant qu'aucun filtrage n'a eu lieu */
  private lastNutsCountryCode: string | undefined = undefined;
  private isNutsFilterApplied = false;


  constructor(
    private autoCompleteService: AutoCompleteService,
    private validatorService: ValidatorService,
    private stepBuilder: StepperBuilderService,
    private errorWafConverterService: ErrorWafConverterService,
    private translateService: TranslateService,
    private modalService: NgbModal,
    private canNavigateInStepperService: CanNavigateInStepperService,
    private eformsSubjectService: EformsSubjectService,
    private cd: ChangeDetectorRef,
    private ren: Renderer2,
    private avisDataTransferService: AvisDataTransferService,
    private eformConditionService: EformConditionsService,
    private eformDataService: EformDataService,
    private eformInfoService: EformInfoService,
    private eformSharedFieldsService: EformSharedFieldsService,
    private eformDynamicListService: EformDynamicListService,
    private eformDuplicableEntityService: EformDuplicableEntityService,
    private indexTrackerService: IndexTrackerService,
    private eformConditionsV2Service: EformConditionsV2Service,
    private eformsFieldCounterService: EformsFieldCounterService,
    private nutsCountryFilterService: NutsCountryFilterService,
    private hostElementRef: ElementRef
  ) {
    this.isPrefActivated = environment.pref === 'true';
  }

  private static removeLastSchemeByType(type, array): string[] {
    let lastId = 0;
    //Plutot que retirer un id de la liste et décaller tous ceux qui sont plus grand que lui de 1 autant retirer le dernier
    //Il s'agit uniquement de la string et non d'un objet, il n'y aura aucune difference
    array.forEach(id => {
      if (id.startsWith(type) && +id.split('-')[1] > lastId) {
        lastId = +id.split('-')[1];
      }
    });
    return array.filter(idSchemes => idSchemes !== (type + '-' + lastId.toString().padStart(4, '0')));
  }

  checkState(radioButton) {
    if (!this.disabled) {
      this.checkRadioButton(radioButton);
    }
  }

  ngAfterViewInit() {
    if (this.name && this.localformGroup.controls[this.name]) {
      if (this.localformGroup.controls[this.name].value !== undefined) {
        this.currentCheckedValue = this.localformGroup.controls[this.name].value;
      }

      // Écouter les changements programmatiques du FormControl pour les radios buttons
      if (this.type === 'radio') {
        this.localformGroup.controls[this.name].valueChanges
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(newValue => {
            this.currentCheckedValue = newValue;
          });
      }

    }
    if (this.isEform) {
      // Utiliser le nouveau système de comptage pour les éléments duplicables
      if (this.subSectionId && this.prefixId) {
        const elementId = this.getElementIdFromPrefixId();

        // Ne pas compter les champs UNK (Unknown/non identifiés)
        // Utiliser la logique de getTypeFromFieldName pour déterminer le type
        const type = this.getTypeFromElementId(elementId);
        if (type !== 'UNK') {
          this.eformsFieldCounterService.incrementCreatedCount(elementId);
        }
      }
    }
  }

  /**
   * Vérifie si le champ doit être affiché en tenant compte du rechargement
   */
  shouldDisplayField(): boolean {
    const elementId = this.getElementIdFromPrefixId();
    return this.isNotForbidden(elementId);
  }

  public ngOnInit() {
    //On ne charge d'un lot à la fois pour des raisons de performance donc l'index dans le repeatablePathWithIndex est toujours 0
    //Il ne faut pas y toucher si les données ne seront plus trouvé
    //Mais il faut distinguer les lots notamment pour les erreurs
    if ((this.prefixId?.includes('GR-Lot') || this.prefixId?.includes('GR-Part')) && this.prefixId.includes('_')) {
      const splittedPrefix = this.prefixId.split('_');
      this.prefixId = splittedPrefix[0] + '_' + this.eformDuplicableEntityService.actuaEntityIndex + '_' + splittedPrefix[2];
    }
    // traiter le cas ou un bloc est à afficher deux fois dans deux endroits différents
    // ce cas particulier concerne la partie facturation
    this.isEform = (Object.keys(this.field).length !== 0);
    if (this.isEform) {
      this.repeatablePathWithIndex = this.getRepeatablePathWithIndexForInput(this.field);
      this.repeatablePathForDuplicableElement.next(this.getRepeatablePathForDuplicableElementFromParent());
      // démarrer par set les valeurs :
      this.label = this.field._label;
      this.type = this.field.displayType.toString();
      this.placeholder = this.field.placeHolder ? this.translateService.instant(this.field.placeHolder) : undefined;
      this.infoBulle = this.field.infoBulle ? this.translateService.instant(this.field.infoBulle) : undefined;

      if (this.field.type.toString() === 'text-multilingual') {
        this.type = this.field.type.toString();
      }

      if (this.field.type.toString() === 'date') {
        this.type = 'date-eform';
      }
      if (this.field.type.toString() === 'time') {
        this.type = 'time';
      }
      if (this.field.type.toString() === 'measure' || this.field.type.toString() === 'amount' || this.field.type.toString() === 'integer' || this.field.type.toString() === 'number') {
        this.type = 'number';
      }
      if (this.type === 'TEXTBOX' && this.field.codeList) {
        this.type = 'COMBOBOX';
      }

      if (this.type === 'COMBOBOX') {
        this.optionsWithCode = [];
        this.optionsWithCodeForModal = [];
        if (this.field.codeList) {
          if (this.field.codeList.toString().includes('bdd_')) {
            if (this.field.codeList.toString().includes('bdd_cpv')) {
              this.autoCompleteService.cpv$
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe(cpv => {
                  this.optionsWithCodeForModal = cpv;
                });
              this.buttonOtherOption = true;
            }
            if (this.field.codeList.toString().includes('bdd_nuts')) {
              this.nutsCountryFieldId = this.nutsCountryFilterService.getCountryFieldIdFor(this.field.id);
              this.autoCompleteService.nuts$
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe(nuts => {
                  this.allNutsOptions = nuts || [];
                  // La liste de référence a changé : le filtrage est refait sans attendre
                  // un changement de pays.
                  this.isNutsFilterApplied = false;
                  this.applyNutsCountryFilter();
                });
              // Le suivi du pays est mis en place avec le groupe du contrôle (watchNutsCountry)
              this.buttonOtherOption = true;
            }
            if (this.field.codeList.toString().includes('bdd_country')) {
              this.autoCompleteService.countries$
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe(countries => {
                  this.optionsWithCode = (countries || []).filter(o => o?.code !== '');
                });
              // Mise en place de cette condition pour gérer le cas où on a le première item par défaut qui a un code à null.
              // On met alors '' pour que le 'Selectionner' s'affiche bien
              if (this.optionsWithCode[0] && this.optionsWithCode[0].code === null && this.optionsWithCode[0].libelle == this.translateService.instant('general.default_list_value')
                && this.field.mandatory?.includes(this.canNavigateInStepperService.currentFormulaire?.split('E_FORM_')[1])
              ) {
                this.optionsWithCode[0].code = '';
              }

              if (this.optionsWithCode[0] && this.optionsWithCode[0].code != '' && (this.optionsWithCode[0].code != null)) {
                if (this.field.mandatory?.includes(this.canNavigateInStepperService.currentFormulaire?.split('E_FORM_')[1])) {
                  this.optionsWithCode.unshift({
                    code: '',
                    libelle: this.translateService.instant('general.default_list_value')
                  });
                } else {
                  this.optionsWithCode.unshift({
                    code: null,
                    libelle: this.translateService.instant('general.default_list_value')
                  });
                }
              }
            }
            if (this.field.codeList.toString().includes('bdd_language')) {
              this.autoCompleteService.language$
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe(language => {
                  this.optionsWithCode = cloneDeep(language);
                });
              if (this.optionsWithCode[0] && this.optionsWithCode[0].code != '' && this.optionsWithCode[0].code != null) {
                if (this.field.mandatory?.includes(this.canNavigateInStepperService.currentFormulaire?.split('E_FORM_')[1])) {
                  this.optionsWithCode.unshift({
                    code: '',
                    libelle: this.translateService.instant('general.default_list_value')
                  });
                } else {
                  this.optionsWithCode.unshift({
                    code: null,
                    libelle: this.translateService.instant('general.default_list_value')
                  });
                }
              }
            }
          } else {
            if (this.field.id.includes('BT-763-Procedure')) {
              this.infoBulle = this.translateService.instant('eform-editable.infobulle.BT-763-Procedure');
            }

            this.field.codeList.forEach(e => {
              this.optionsWithCode.push({
                'libelle': this.translateService.instant(e),
                'code': e.split('.').pop()
              });
            });
            // 🔧 FIX 2026-02-10: Désactivation des presetValue - ne plus filtrer les options
            this.optionsWithCode = this.autoCompleteService.translateAndSort(this.optionsWithCode);
            if (this.optionsWithCode[0] && this.optionsWithCode[0].code != '' && this.optionsWithCode[0].code != null) {
              if (this.field.mandatory?.includes(this.canNavigateInStepperService.currentFormulaire?.split('E_FORM_')[1])) {
                this.optionsWithCode.unshift({
                  code: '',
                  libelle: this.translateService.instant('general.default_list_value')
                });
              } else {
                this.optionsWithCode.unshift({
                  code: null,
                  libelle: this.translateService.instant('general.default_list_value')
                });
              }

            }
          }
        } else if (this.field._idSchemes) {
          this.eformsSubjectService.idSchemeListSubject.pipe(takeUntil(this.unsubscribeIdSchemeList$)).subscribe({
            next: (data: string[]) => {
              let updatedOptions = [];
              this.field._idSchemes.forEach(scheme => {
                data.filter(e => e.includes(scheme)).forEach(el => {
                  const existingOptionIndex = this.optionsWithCode.findIndex(option => option.code === el);
                  // Si l'élément n'existe pas déjà, l'ajouter à updatedOptions
                  if (existingOptionIndex === -1) {
                    updatedOptions.push({code: el, libelle: el});
                  } else {
                    // Si l'élément existe déjà, le copier tel quel dans updatedOptions
                    updatedOptions.push(this.optionsWithCode[existingOptionIndex]);
                  }
                });
              });
              this.optionsWithCode = updatedOptions;
              if (this.optionsWithCode[0] && this.optionsWithCode[0].code != '' && this.optionsWithCode[0].code != null) {
                if (this.field.mandatory?.includes(this.canNavigateInStepperService.currentFormulaire?.split('E_FORM_')[1])) {
                  this.optionsWithCode.unshift({
                    code: '',
                    libelle: this.translateService.instant('general.default_list_value')
                  });
                } else {
                  this.optionsWithCode.unshift({
                    code: null,
                    libelle: this.translateService.instant('general.default_list_value')
                  });
                }
              }
              if (Object.values(orgFields).includes(this.field.id)) {
                this.addOrgName();
              }
              if (this.field.id.includes('OPT-310-Tender')) {
                this.addTendererName();
              }
              if (this.field.id.includes('OPT-320-LotResult')) {
                this.addOfferName();
              }
            }
          });
        } else {
          this.options = [];
          this.options.push('TO_ANALYSE');
        }
        this.type = 'select';
      }
      if (this.field.type.toString() === 'currencyID') {
        if (this.field.codeList.toString().includes('bdd_currency')) {
          this.autoCompleteService.currency$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(currency => {
              this.optionsWithCode = cloneDeep(currency);
            });
          this.optionsWithCode = this.autoCompleteService.translateAndSort(this.optionsWithCode);
          if (this.optionsWithCode[0] && this.optionsWithCode[0].code != '') {
            if (this.field.mandatory?.includes(this.canNavigateInStepperService.currentFormulaire?.split('E_FORM_')[1])) {
              this.optionsWithCode.unshift({
                code: '',
                libelle: this.translateService.instant('general.default_list_value')
              });
            } else {
              this.optionsWithCode.unshift({
                code: null,
                libelle: this.translateService.instant('general.default_list_value')
              });
            }
          }
        }
        this.type = 'currencyid';
      }
      if (this.field.type.toString() === 'unitCode') {
        if (this.field.codeList.toString().includes('bdd_unitcode')) {
          this.autoCompleteService.durationUnit$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(durationUnit => {
              this.optionsWithCode = cloneDeep(durationUnit);
            });
          this.optionsWithCode = this.autoCompleteService.translateAndSort(this.optionsWithCode);
          if (this.optionsWithCode[0] && this.optionsWithCode[0].code != '') {
            if (this.field.mandatory?.includes(this.canNavigateInStepperService.currentFormulaire?.split('E_FORM_')[1])) {
              this.optionsWithCode.unshift({
                libelle: this.translateService.instant('general.default_list_value'),
                code: ''
              });
            } else {
              this.optionsWithCode.unshift({
                libelle: this.translateService.instant('general.default_list_value'),
                code: null
              });
            }
          }
        }
        this.type = 'unitcode';
      }
      if (this.type === 'RADIO') {
        this.radios = [];

        if (this.field.codeList) {
          this.field.codeList.forEach(code => {
            this.radios.push({value: code.split('.').pop(), label: this.translateService.instant(code)});
          });
        } else {
          this.radios.push({value: true, label: 'Oui'});
          this.radios.push({value: false, label: 'Non'});
        }
        this.type = 'radio';
      }
      let formInput = FormInputFactory.createEformsElement(this.field,
        this.parentForm, this.disabled, this.repeatablePath, this.noticeValue, this.repeatablePathWithIndex,
        this.canNavigateInStepperService.currentFormulaire, this.prefixId, this.modalValue, this.groupOrSectionId, this.translateService, this.arrayLength, this.lastElementArray, this.eformsSubjectService, this.fieldLastArray, this.canNavigateInStepperService, this.avisDataTransferService, this.repeatablePathForDuplicableElement);

      this.specByField();
      this.name = formInput.name;
      this.repeatablePathWithIndex = formInput.repeatablePathWithIndex;

      if (this.field.type === 'time') {
        setTimeout(() => {
          this.cd.detectChanges();
        }, 0);
      }

      if (this.optionsWithCodeForModal?.length > 0 && this.canNavigateInStepperService.currentValue) {
        this.optionsWithCode.push({
          code: this.canNavigateInStepperService.currentValue,
          libelle: this.optionsWithCodeForModal[this.optionsWithCodeForModal.findIndex(e => e.code == this.canNavigateInStepperService.currentValue)].libelle
        });
        this.canNavigateInStepperService.currentValue = null;
      }
      if (formInput.type === 'arrayeform') {
        this.type = formInput.type;
      }
      this.updateIndexForDuplicableObjects(formInput);
      this.idFromName = (this.prefixId ? this.prefixId + '|' : '') + this.field.id + formInput.sepSep;

      this.pathElements = formInput.elements;
      this.localformGroup = formInput.formGroup;
      this.hidden = this.field.hidden;
      if (this.nutsCountryFieldId) {
        this.watchNutsCountry();
      }

      // Ajout de ce contrôle sur les valueChanges pour remplacer le (change)="endOfFocus()"
      // (change)="endOfFocus()" était appelé jsute après le changement de valeur mais seulement avec un setTimeout
      // Avec le valueChanges, ils sont tous les deux appelés immédiatement
      const control = this.localformGroup.get(this.name);
      if (control) {
        control.valueChanges.subscribe(() => {
          this.endOfFocus();
        });
      }

      // Historique : la valeur correcte est bien présente dans le FormGroup du composant (vérifié
      // par logs : le contrôle contient bien l'heure attendue dès la 1re visite d'un lot), mais
      // l'<input> affiché reste vide. L'élément rendu est en pratique lié à une AUTRE instance de
      // contrôle que celle que l'on alimente ici (instances remplacées / groupes recréés pendant le
      // chargement asynchrone du lot), et Angular ne re-bind pas une directive déjà initialisée.
      // D'où le symptôme "1re visite du lot : champ vide / 2e visite : champ valorisé".
      //
      // Plutôt que de tenter de retrouver l'instance exacte à laquelle la directive est liée (fragile
      // et dépendant de l'ordre d'initialisation), on écrit directement dans l'élément natif puis on
      // émet un événement 'input' : le ControlValueAccessor du contrôle réellement lié capte cet
      // événement et se met à jour, ce qui laisse formulaire et affichage cohérents.
      if (this.field.type === 'time' || this.field.type === 'date') {
        const lotIndexForCache = FormInputFactory.extractLotIndexForCache(this.prefixId);
        if (lotIndexForCache !== null) {
          const timeCacheKey = `${lotIndexForCache}_SEPSEP_${this.field.id}`;
          const cachedValue = FormInputFactory.getTimeFieldCacheValue(timeCacheKey);
          if (cachedValue) {
            if (control && control.value !== cachedValue) {
              control.setValue(cachedValue);
            }
            setTimeout(() => {
              const inputSelector = this.field.type === 'date' ? 'input[type="date"]' : 'input[type="time"]';
              const nativeInput: HTMLInputElement = this.hostElementRef?.nativeElement
                ?.querySelector(inputSelector);
              if (nativeInput && !nativeInput.value) {
                nativeInput.value = cachedValue;
                nativeInput.dispatchEvent(new Event('input', {bubbles: true}));
                nativeInput.dispatchEvent(new Event('change', {bubbles: true}));
              }
            }, 0);
          }
        }
      }

      return;
    } else {
      // dans le cas de l'absence de la rule intialiser la valeur
      if (this.rule === undefined || this.rule == null) {
        this.rule = '';
      }
      // dans le cas de l'absence du label intialiser la valeur
      if (this.label === undefined || this.label == null) {
        this.label = '';
      }
      /*       // dans le cas de l'absence du placeholder intialiser la valeur
            if (this.placeholder === undefined || this.placeholder == null) {
              this.placeholder = '';
            }
            // dans le cas de l'absence du infoBulle intialiser la valeur
            if (this.infoBulle === undefined || this.infoBulle == null) {
              this.infoBulle = '';
            } */
      if (this.parentForm.controls[this.name] !== undefined) {
        this.localformGroup = this.parentForm;
        // only for test // désactiver l'écrasement des valeurs
        if (environment.profile === 'test') {
          return;
        }

        this.idFromName = this.name + '_1';
        // Pour les chips avec autoComplete, filtrer les valeurs vides avant de mettre à jour le FormControl
        if (this.type === this.CHIPS && Array.isArray(this.value)) {
          this.value = this.value.filter((val: any) => val && (typeof val !== 'string' || val.trim() !== ''));
        }
        this.parentForm.controls[this.name].setValue(this.value);
        this.LOG.debug('[UPDATE][ ', this.type, ' | ', this.name, ' | ', this.parentForm.controls[this.name], ' | ', this.value);

        // FIX: Initialiser currentCheckedValue dès ngOnInit pour les radio buttons
        // afin que [checked] soit correct dès le premier rendu (et non en ngAfterViewInit)
        if (this.type === this.RADIO) {
          this.currentCheckedValue = this.value;
        }

        // FIX: reconstruire selectedOptions pour les chips quand le contrôle existe déjà
        // Sans cela, les chips ne sont pas affichés visuellement même si le FormControl a la bonne valeur
        if (this.type === this.CHIPS) {
          this.selectedOptions = [];
          this.value?.forEach(item => {
            // Ignorer les valeurs vides pour éviter de matcher le premier élément de l'autocomplete
            if (!item || (typeof item === 'string' && item.trim() === '')) {
              return;
            }
            if (this.autoCompleteType !== undefined) {
              const filtered = this.filter(item);
              if (filtered.length > 0 && filtered[0]?.code !== '') {
                this.selectedOptions.push(filtered[0]);
              } else if (this.rule === 'pattern_5' ) {
                // PRB0052636: ajouter ce else pour afficher aussi les valeurs qui ne sont pas dans la liste,
                // mais enregistrées dans la base, afin de permettre la correction à l'utilisateur
                this.selectedOptions.push(item);
              }
            } else {
              this.selectedOptions.push(item);
            }
          });
        }

        return;
      }
      this.idFromName = this.name;
      if (this.type === this.AUTO_COMPLETE || this.type === this.CHIPS || this.type === this.AUTO_COMPLETE_WITH_STAR) {
        if (this.type === this.CHIPS) {
          // Dans le cas des chips
          this.value?.forEach(item => {
            // Ignorer les valeurs vides pour éviter de matcher le premier élément de l'autocomplete
            if (!item || (typeof item === 'string' && item.trim() === '')) {
              return;
            }
            if (this.autoCompleteType !== undefined) {
              const filtered = this.filter(item);
              if (filtered.length > 0 && filtered[0]?.code !== '') {
                this.selectedOptions.push(filtered[0]);
              }  else if (this.rule === 'pattern_5' ) {
                // PRB0052636: ajouter ce else pour afficher aussi les valeurs qui ne sont pas dans la liste,
                // mais enregistrées dans la base, afin de permettre la correction à l'utilisateur
                this.selectedOptions.push(item);
              }
            } else {
              this.selectedOptions.push(item);
            }
          });

          this.parentForm.addControl(this.name + '_' + this.CHIPS, new FormControl({
            value: '',
            disabled: this.disabled
          }));
          if (this.autoCompleteType !== undefined) {
            this.filteredOptions = this.parentForm.valueChanges.pipe(
              map((ctrs) => {
                return ctrs[this.name + '_' + this.CHIPS];
              }),
              map((value) => (value ? this.filter(value) : []))
            );
          }
        } else {
          // dans le cas des chips avec ou sans étoile
          this.filteredOptions = this.parentForm.valueChanges.pipe(
            map((ctrs) => {
              return ctrs[this.name];
            }),
            map((value) => (value ? this.filter(value) : []))
          );
        }
      } else {
        this.autoCompleteService = null;
      }
      if (this.type === this.RADIO) {
        for (const rad of this.radios) {
          if (rad.id || rad.checked || rad.disabled) {
            throw Error('[RADIO][FORBIDDEN FIELD][ID | CHECKED | DISABLED]' + this.name);
          }
          // autoriser temporairement les valeurs null | rad.value === null ||
          if (rad.value === undefined || !rad.label) {
            throw Error('[RADIO][MANDATORY FIELD][VALUE | LABEL]' + this.name);
          }
        }
      }
      if (this.parentForm) {
        this.localformGroup = this.parentForm;

        if (this.type === this.DATE) {
          // Si la valeur est null ou undefined, initialiser avec DATE_FORMAT
          if (this.value === null || this.value === undefined) {
            this.value = this.DATE_FORMAT;
          }

          // Vérifier si la date est valide
          if (!this.isValidDate(this.value)) {
            // Si la date est invalide, réinitialiser à DATE_FORMAT
            this.value = this.DATE_FORMAT;
          }

          const previousDate = this.value;
          this.timestamp = this.getTimestamp(this.value);
          this.value = this.convertDate(this.value);

          this.parentForm.addControl(this.name + '_' + this.TIME_STAMP, new FormControl(this.timestamp));
          this.parentForm.addControl(
            this.name,
            new FormControl({value: this.value, disabled: this.disabled},
              this.validatorService.getValidator(this.rule === 'required' ? this.rule + 'Date' : this.rule))
          );

          this.LOG.debug('[CREATE] : ', this.type, ' | ', this.name, ' | ', this.value, ' | ', previousDate);
          this.LOG.debug('[CREATE] : ', this.type, ' | ', this.name + '_' + this.TIME_STAMP, ' | ', this.timestamp, ' | ', previousDate);

          if (this.errorMessage) {
            this.stepBuilder.stepFieldsSpecificMessages.set(this.name, this.errorMessage);
          }


        } else if (this.type === 'time') {
          // Extraire l'heure (HH:mm:ss) à partir d'une valeur ISO complète envoyée par le
          // préremplissage (ex: "2024-09-16T17:30:00.000+02:00"), à l'instar de convertDate()
          // pour le champ date. Sans cette extraction, l'input HTML type="time" natif rejette
          // silencieusement toute valeur qui n'est pas strictement au format HH:mm ou HH:mm:ss.
          const previousTime = this.value;
          this.value = this.convertTime(this.value);

          this.parentForm.addControl(
            this.name,
            new FormControl({value: this.value, disabled: this.disabled},
              this.validatorService.getValidator(this.rule))
          );

          this.LOG.debug('[CREATE] : ', this.type, ' | ', this.name, ' | ', this.value, ' | ', previousTime);

          if (this.errorMessage) {
            this.stepBuilder.stepFieldsSpecificMessages.set(this.name, this.errorMessage);
          }

        } else if (this.type === this.DATETIME) {

          if (this.value === null || this.value === undefined) {
            this.value = this.DATETIME_FORMAT;
          }

          // Vérifier si la date est valide
          if (!this.isValidDate(this.value)) {
            // Si la date est invalide, réinitialiser à DATETIME_FORMAT
            this.value = this.DATETIME_FORMAT;
          }

          const previousDate = this.value;
          this.timestamp = this.getTimestamp(this.value);


          this.parentForm.addControl(this.name + '_' + this.TIME_STAMP, new FormControl(this.timestamp));
          this.parentForm.addControl(
            this.name,
            new FormControl({value: this.value, disabled: this.disabled},
              this.validatorService.getValidator(this.rule === 'required' ? this.rule + 'Date' : this.rule))
          );


          this.LOG.debug('[CREATE] : ', this.type, ' | ', this.name, ' | ', this.value, ' | ', previousDate);
          this.LOG.debug('[CREATE] : ', this.type, ' | ', this.name + '_' + this.TIME_STAMP, ' | ', this.timestamp, ' | ', previousDate);
        } else if (this.type === this.CHECK_BOX) {
          if (this.checkboxDestination !== this.CHECK_BOX_STRING
            && this.checkboxDestination !== this.CHECK_BOX_OBJECT &&
            this.checkboxDestination !== this.CHECK_BOX_LIST &&
            this.checkboxDestination !== this.CHECK_BOX_BOOLEAN) {
            throw Error('[CHECKBOX-TYPE-ERROR][checkboxDestination not setted] : ' + this.name + this.checkboxDestination);
          } else {
            this.LOG.debug('[CREATE]1[ ', this.type + '-' + this.checkboxDestination, ' | ', this.name, ' | ', this.value);
            if (this.checkboxDestination === this.CHECK_BOX_STRING) {
              if (this.value === undefined) {
                throw Error('[CHECKBOX-TYPE-ERROR][value setted for string] : ' + this.name + this.checkboxDestination);
              }
              this.parentForm.addControl(
                this.name,
                new FormControl(
                  {value: this.value === this.isChecked, disabled: this.disabled},
                  this.validatorService.getValidator(this.rule)
                )
              );
            } else if (this.checkboxDestination === this.CHECK_BOX_BOOLEAN) {
              if (this.value === undefined) {
                throw Error('[CHECKBOX-TYPE-ERROR][value setted for boolean] : ' + this.name + this.checkboxDestination);
              }
              this.parentForm.addControl(
                this.name,
                new FormControl(
                  {value: this.value, disabled: this.disabled},
                  this.validatorService.getValidator(this.rule)
                )
              );
            } else if (this.checkboxDestination === this.CHECK_BOX_OBJECT) {
              if (this.isChecked) {
                throw Error('[CHECKBOX-TYPE-ERROR][isChecked setted for object] : ' + this.name + this.checkboxDestination);
              }
              this.parentForm.addControl(
                this.name,
                new FormControl(
                  {value: this.value != null && this.value !== undefined, disabled: this.disabled},
                  this.validatorService.getValidator(this.rule)
                )
              );
            } else {
              this.parentForm.addControl(
                this.name,
                new FormControl(
                  {
                    value: this.value != null && this.value !== undefined && this.value.length > 0,
                    disabled: this.disabled
                  },
                  this.validatorService.getValidator(this.rule)
                )
              );
            }
          }
        } else {
          if (this.type === this.NUMBER) {
            this.rule += '|pattern_36';
          }
          if (this.type === this.PERCENTAGE) {
            this.rule += '|pattern_37';
          }
          if (this.type === this.MONEY) {
            this.rule += '|min_0|pattern_38';
          }
          if (this.rule && this.rule.indexOf('|') === 0) {
            this.rule = this.rule.substring(1);
          }
          this.parentForm.addControl(
            this.name,
            new FormControl({value: this.value, disabled: this.disabled}, this.validatorService.getValidator(this.rule))
          );
          const acTypeStrForValidation = typeof this.autoCompleteType === 'string'
            ? this.autoCompleteType
            : AutoCompleteType[this.autoCompleteType];
          if (acTypeStrForValidation === AutoCompleteType[AutoCompleteType.CPV] && this.autoCompleteService) {
            const cpvControl = this.parentForm.get(this.name);
            const cpvExistsValidator = existsInReferenceListValidator(
              () => this.autoCompleteService.getOptions(AutoCompleteType[AutoCompleteType.CPV])
            );
            const existingValidator = cpvControl.validator;
            cpvControl.setValidators(
              existingValidator ? Validators.compose([existingValidator, cpvExistsValidator]) : cpvExistsValidator
            );
            cpvControl.updateValueAndValidity({ onlySelf: true, emitEvent: false });
          }
          // FIX: Initialiser currentCheckedValue dès ngOnInit pour les radio buttons
          // afin que [checked] soit correct dès le premier rendu (et non en ngAfterViewInit)
          if (this.type === this.RADIO) {
            this.currentCheckedValue = this.value;
          }
          this.LOG.debug('[CREATE][ ', this.type, ' | ', this.name, ' | ', this.value, ' | ', this.disabled);
          if (this.errorMessage) {
            this.stepBuilder.stepFieldsSpecificMessages.set(this.name, this.errorMessage);
          }
        }
      }
    }
    if ((this.type === 'text' || this.type === 'textWithStar' || this.type === 'autocompleteWithStar'
        || this.type === ' autocomplete' || this.type === 'chips') &&
      this.errorWafConverterService.getControlNameList().findIndex(v => v === this.name) === -1) {
      this.errorWafConverterService.getControlNameList().push(this.name);
    }
  }

  addField() {
    this.newField.emit(this.field);
  }

  removeField() {
    //suppression à l'affichage
    this.deleteField.emit(this.field);

    if (this.field) {
      let fieldLastArray = this.field?.jsonPath?.substring(0, this.field?.jsonPath?.lastIndexOf('[]'));
      fieldLastArray = fieldLastArray?.substring(fieldLastArray?.lastIndexOf('.') + 1);
      let level = this.field.jsonPath?.split('.').length - this.field.jsonPath?.split('.').indexOf(fieldLastArray + '[]') - 1;
      let tempControl = this.localformGroup;
      let tempControlParent;
      for (let i = 0; i < level; i++) {
        tempControlParent = tempControl;
        tempControl = tempControl?.parent;
      }
      if (tempControlParent && Array.isArray(tempControl?.controls) && tempControl?.controls?.indexOf(tempControlParent) != -1) {
        tempControl?.removeAt(tempControl?.controls?.indexOf(tempControlParent));
      }
    }
  }

  public hasError() {
    // TODO : gérer le cas des fields
    if (Object.keys(this.field).length !== 0) {
      return;
    }
    if (this.deletedControlName.includes(this.name)) {
      return;
    }
    const onSubmit = this.parentForm.controls.submitted?.value;
    return FormInputErrorTools.hasError(this.parentForm, this.name, onSubmit);
  }

  public isRequired() {
    // ✅ FIX 2026-01-16: Pour les eforms, vérifier d'abord localformGroup qui contient le contrôle
    // Cela corrige le problème où l'étoile rouge n'apparaissait pas sur les lots 2, 3, etc.
    // car le contrôle n'était pas trouvé directement dans parentForm pour les éléments duplicables.
    if (this.isEform && this.localformGroup?.controls?.[this.name]) {
      if (this.localformGroup.controls[this.name].validator) {
        const validator = this.localformGroup.controls[this.name].validator({} as AbstractControl);
        if (validator && validator.required) {
          return true;
        }
      }
      return false;
    }

    if (this.parentForm.controls[this.name]) {
      if (this.parentForm.controls[this.name].validator) {
        const validator = this.parentForm.controls[this.name].validator({} as AbstractControl);
        if (validator && validator.required) {
          return true;
        }
      }
      return false;
    } else {
      if (this.pathElements) {
        let tempControl;
        tempControl = this.eformsSubjectService.getField(this.pathElements, this.parentForm, this.repeatablePathWithIndex, this.field);
        if (tempControl?.validator) {
          const validator = tempControl.validator({} as AbstractControl);
          if (validator && validator.required) {
            return true;
          }
        }
        return false;
      }
      // TODO : to activate
      // this.LOG.error('[isRequired][Contrôle inexistant] : ' + this.name);
      return false;
    }
  }

  add(event: MatChipInputEvent): void {
    if (this.onError) {
      return;
    }
    const input = event.input;
    const value = event.value;

    if (((value || '').trim() && this.maxLength === undefined)
      || ((value || '').trim() && this.maxLength !== undefined && this.selectedOptions.length < this.maxLength)) {

      this.selectedOptions.push(value.trim());
    }

    if (input) {
      input.value = '';
    }

    // Si autoCompleteType est défini, on ne stocke que les codes (strings) dans le formControl,
    // comme le fait la méthode selected(), pour éviter un mélange d'objets et de strings.
    if (this.autoCompleteType !== undefined) {
      this.selectedCodes = this.selectedOptions.map(e => (typeof e === 'object' && e?.code) ? e.code : e);
      this.parentForm.get(this.name).setValue(this.selectedCodes.filter(e => e !== ''));
    } else {
      this.parentForm.get(this.name).setValue(this.selectedOptions);
    }
  }

  remove(value: string): void {
    let index = -1;
    if (this.autoCompleteType !== undefined) {
      index = this.selectedOptions.findIndex(opt =>
        (typeof opt === 'object' && (opt.code === value || opt.libelle === value)) ||
        (typeof opt === 'string' && opt === value)
      );
    } else {
      if (value === undefined) {
        index = this.selectedOptions.length - 1;
      } else {
        index = this.selectedOptions.indexOf(value);
      }
    }
    if (index >= 0) {
      this.selectedOptions.splice(index, 1);

      if (this.autoCompleteType !== undefined) {
        this.selectedCodes = this.selectedOptions.map(e => e.code);
        this.parentForm.get(this.name).setValue(this.selectedCodes.filter(e => e !== ''));
      } else {
        this.parentForm.get(this.name).setValue([...this.selectedOptions.filter(e => !!e)]);
      }
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (this.maxLength === undefined || (this.selectedOptions.length < this.maxLength)) {
      if (this.selectedOptions === null) {
        this.selectedOptions = [];
      }
      this.selectedOptions.push(this.filter(event.option.value)[0]);
      for (var i = 0; i < this.selectedOptions.length; i++) {
        if (this.selectedCodes.indexOf(JSON.parse(JSON.stringify(this.selectedOptions[i])).code) < 0) {
          this.selectedCodes.push(JSON.parse(JSON.stringify(this.selectedOptions[i])).code);
        }
      }
      this.chipsInput.nativeElement.value = '';
      this.parentForm.get(this.name).setValue(this.selectedCodes.filter(e => e != ''));
    }
  }

  chargerListe(el) {
    this.selectedOptions.push(el.value);
  }

  endOfFocus() {
    if (this.field?.id) {
      const currentValue = this.type === 'radio' ? this.currentCheckedValue : this.localformGroup.value.val;

      // Pour les champs partagés : ne jamais écrire de valeur vide/null dans le JSON partagé
      // car cela viderait l'autre champ qui partage le même emplacement
      if (this.eformSharedFieldsService.isSharedLocationField(this.field.id) &&
        (currentValue === null || currentValue === undefined || currentValue === '' || currentValue === 'null')) {
        return;
      }

      const path = this.repeatablePathForDuplicableElement.getValue();
      if (typeof path === 'string') {
        // ✅ FIX 2026-01-20: Mettre à jour directement le flatFields pour garder toutes les valeurs synchronisées
        // Cela résout le problème où les conditions basées sur des éléments duplicables non chargés
        // ne trouvaient pas les valeurs (ex: OPT-321-Tender pour les offres non affichées)
        const duplicableInfo = this.eformConditionsV2Service.extractDuplicableInfo(path, this.field.id);


        if (duplicableInfo.type && duplicableInfo.index !== null) {
          // Utiliser l'index réel affiché si disponible
          const realIndex = this.eformConditionsV2Service.getDisplayedRealIndex(duplicableInfo.type);
          const effectiveIndex = realIndex !== undefined ? realIndex : duplicableInfo.index;
          this.eformConditionsV2Service.updateFlatFieldValue(
            this.field.id,
            currentValue,
            duplicableInfo.type,
            effectiveIndex
          );
        } else {
          // Champ non duplicable
          this.eformConditionsV2Service.updateFlatFieldValue(this.field.id, currentValue);
        }

        if (path.includes('procurementprojectlot[]')) {
          let prefixId = this.prefixId;
          let lotIndexMatch = prefixId.match(/GR-Lot_(\d+)_\d+/);
          let newIndex = lotIndexMatch ? lotIndexMatch[1] : '0';

          let updatedPath = path.replace(/procurementprojectlot\[\]0/, `procurementprojectlot[]${newIndex}`);
          // Dans le cas d'un radiobouton, on utilise la valeur actuelle du bouton radio
          this.eformDuplicableEntityService.setValueFromPath(this.eformDuplicableEntityService.avisWithElementsDuplicable?.getValue?.()?.jsonsaisieformulaire.ann, updatedPath, 'val', this.type === 'radio' ? this.currentCheckedValue : this.localformGroup.value.val);
        } else {
          // Dans le cas d'un radiobouton, on utilise la valeur actuelle du bouton radio
          this.eformDuplicableEntityService.setValueFromPath(this.eformDuplicableEntityService.avisWithElementsDuplicable?.getValue?.()?.jsonsaisieformulaire.ann, path, 'val', this.type === 'radio' ? this.currentCheckedValue : this.localformGroup.value.val);
        }
      }

      if (this.field.id.includes('BT-500-Organization-Company')) {
        this.eformDynamicListService.setOrganizationName(this.parentForm, this.eformDuplicableEntityService.listDuplicableEntity.getValue().filter(e => e.id.includes('ORG')));
      }
      if (this.field.id.includes('OPT-211-Tenderer')) {
        this.eformDynamicListService.setTendererName(this.parentForm, this.eformDuplicableEntityService.listDuplicableEntity.getValue().filter(e => e.id.includes('TPA')));
      }
      if (this.field.id.includes('BT-3201-Tender')) {
        this.eformDynamicListService.setOfferName(this.parentForm, this.eformDuplicableEntityService.listDuplicableEntity.getValue().filter(e => e.id.includes('TEN')));
      }
      if (this.field.id.includes('BT-21-Lot') || this.field.id.includes('BT-21-Part')) {
        this.eformDynamicListService.setLotName(this.parentForm, this.eformDuplicableEntityService.listDuplicableEntity.getValue().filter(e => e.id.includes('LOT') || e.id.includes('PAR')));
      }
    }
    if (Object.keys(this.field).length !== 0) {
      if (this.field.type == 'time' && this.localformGroup.value.val && this.localformGroup.value.val.match(/^\d?\d?:\d?\d?$/)) {
        let currentValueSplitted = this.localformGroup.value.val.split(':');
        let hours = currentValueSplitted[0];
        let min = currentValueSplitted[1];
        let corrected = hours.padStart(2, 0) + ':' + min.padStart(2, 0) + ':00';

        // Désactiver temporairement les abonnements valueChanges
        const control = this.localformGroup.get('val');
        if (control) {
          const subs = control.valueChanges.observers;
          const tempObservers = [...subs];
          subs.length = 0;  // Vider les observers temporairement

          this.localformGroup.patchValue({['val']: corrected}, {emitEvent: false});

          // Restaurer les observers
          subs.push(...tempObservers);
        }

        this.cd.detectChanges();
      }
    }
  }

  timeformat(e) {
    if (this.type == 'time' && this.field?.pattern == '^(([01]\\d|2[0-3])((:[0-5]\\d){1,2}(\\.\\d+)?)?)(Z|[-+]((0[0-9]|1[0-3]):([03]0|45)|14:00))$') {
      if (isNaN(e.key) && e.key !== ':' && e.key !== 'Backspace') {
        e.preventDefault();
      }
    }
  }

  ngOnDestroy(): void {
    // ✅ FIX 2025-12-23: Ne pas retirer les contrôles du FormArray quand on est dans un élément duplicable
    // Cela corrige le problème où organization: [] devient vide lors de la navigation 1→3→2
    // car les composants étaient détruits par le *ngIf du template et retiraient leurs contrôles
    //
    // Ajout de 'GR-Lot' à cette liste. Le lot lui-même (contrairement à ses
    // sous-éléments GR-LotTender/GR-LotResult déjà couverts) n'était pas protégé, ce qui provoquait
    // la suppression silencieuse de champs comme BT-131(t)-Lot (heure de la DLRO) lors de la
    // navigation entre onglets de lots : le contrôle était retiré à la destruction du composant,
    // puis recréé sans conserver la valeur correctement chargée l'instant d'avant.
    const isDuplicableElement = this.subSectionId &&
      (this.subSectionId.includes('GR-Organisations') ||
        this.subSectionId.includes('GR-SettledContract') ||
        this.subSectionId.includes('GR-LotTender') ||
        this.subSectionId.includes('GR-LotResult') ||
        this.subSectionId.includes('GR-Lot') ||
        this.subSectionId.includes('GR-TenderingParty'));

    if (this.parentForm && !isDuplicableElement) {
      if (this.type === this.DATE) {
        this.parentForm.removeControl(this.name + '_' + this.TIME_STAMP);
        this.deletedControlName.push(this.name + '_' + this.TIME_STAMP);
      }
      this.deletedControlName.push(this.name);
      if (this.type === this.CHIPS) {
        this.parentForm.removeControl(this.name + '_' + this.CHIPS);
      }
      if (this.parentForm.contains(this.name)) {
        this.parentForm.removeControl(this.name);
      }
      this.removeField();
      if (this.field._idScheme && !Object.values(DuplicableElementsIdSchemeEnum).includes(this.field._idScheme)) {
        if (!this.modalOpen) {
          let array = this.eformsSubjectService.idSchemeListSubject.getValue();
          if (this.field._idScheme) {
            array = FormInputComponent.removeLastSchemeByType(this.field._idScheme, array);
            this.eformsSubjectService.setIdSchemeListSubject(array);
          }
        } else {
          this.modalOpen = false;
        }
      }
      if (this.groupOrSectionId) {
        this.eformConditionService.clearExistingItemsListById(this.groupOrSectionId);
      }
    }
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.unsubscribeIdSchemeList$.next();
    this.unsubscribeIdSchemeList$.complete();
  }

  getEvent() {
    const modalRef = this.modalService.open(InformationComponent);
    modalRef.componentInstance.title = this.label;
    modalRef.componentInstance.content = this.infoBulle;
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  controlValue(event: FocusEvent) {
    const controlName = (event.target as HTMLInputElement).id;
    let actualControl;
    if (!this.isFieldEmpty()) {
      actualControl = this.localformGroup;
    } else {
      actualControl = this.parentForm.controls[controlName];
    }
    if (isNaN((event.target as HTMLInputElement).valueAsNumber)) {
      actualControl.getError('pattern');
    }
    actualControl.setValue(actualControl.value);
  }

  keyDownControl(event: KeyboardEvent) {
    if (['+', '-', 'e'].includes(event.key)) {
      event.preventDefault();
    }
  }

  chargeDonneePreference(preference: Preference) {
    if (this.isEform && this.preferenceType === PreferenceType.CODES_CPV) {
      this.optionsWithCode.push({code: preference.content.values[0].code, libelle: preference.content.values[0].value});
      this.eformsSubjectService.updateField(this.repeatablePathWithIndex, this.field.jsonPath, this.parentForm, 'val', preference.content.values[0].code, this.type, this.field);
    } else {
      this.preferenceSelected.emit(preference);
    }
    if (this.preferenceType.includes('ACHETEUR')) {
      this.eformDynamicListService.setOrganizationName(this.parentForm, this.eformDuplicableEntityService.listDuplicableEntity.getValue().filter(e => e.id.includes('ORG')));
    }
  }

  isFieldEmpty() {
    return Object.keys(this.field).length === 0;
  }

  /**
   * Restreint la liste des codes NUTS proposés à ceux du pays saisi dans le champ
   * associé, et vide la valeur lorsque ce pays est remplacé par un autre.
   *
   * Aucun code n'est proposé pour un pays dépourvu de codes NUTS ni pour un pays
   * non renseigné : seule l'option vide reste dans le select.
   */
  private applyNutsCountryFilter(): void {
    if (!this.nutsCountryFieldId) {
      // Champ code NUTS sans champ pays associé : la liste reste complète
      this.optionsWithCode = this.allNutsOptions;
      this.optionsWithCodeForModal = this.allNutsOptions;
      return;
    }

    const countryCode = this.getNutsCountryCode();
    const isFirstPass = this.lastNutsCountryCode === undefined;
    const hasCountryChanged = !isFirstPass && this.lastNutsCountryCode !== countryCode;

    if (isFirstPass) {
      this.lastNutsCountryCode = countryCode;
    } else if (hasCountryChanged) {
      const previousCountryCode = this.lastNutsCountryCode;
      this.lastNutsCountryCode = countryCode;
      // Seul le remplacement d'un pays connu vide la valeur. À l'ouverture d'un avis,
      // le premier filtrage peut avoir lieu avant le chargement des données : le pays
      // lu est alors null, et l'arrivée du pays enregistré n'est pas une modification.
      // Un code NUTS présent sans pays provient toujours des données chargées : le
      // champ est interdit tant que le pays n'est pas renseigné.
      // Pendant le rechargement d'un élément duplicable, d'une préférence ou d'un
      // avis lié, le pays et le code NUTS n'arrivent pas dans le même cycle :
      // la valeur chargée serait effacée alors que le pays n'a pas été modifié.
      if (previousCountryCode != null && !this.isLoadingAvisData()) {
        this.clearNutsValue();
      }
    }

    // Hors changement de pays, la liste n'est pas reconstruite : openModalOtherOption()
    // réduit optionsWithCode au seul code sélectionné pour l'afficher dans le select.
    if (isFirstPass || hasCountryChanged || !this.isNutsFilterApplied) {
      const nutsOfCountry = this.nutsCountryFilterService.filterNutsByCountry(this.allNutsOptions, countryCode);
      this.optionsWithCodeForModal = nutsOfCountry;
      // Le select porte une option vide en tête : sans option correspondant à une
      // valeur vide, le navigateur sélectionne le premier code de la liste.
      // La modale de recherche, elle, ne reçoit que les codes NUTS.
      this.optionsWithCode = [
        {code: '', libelle: 'general.default_list_value'},
        ...nutsOfCountry
      ];
      this.isNutsFilterApplied = true;
    }

    this.checkNutsValueOfCountry();
  }

  /**
   * Traite un code NUTS enregistré qui n'appartient pas au pays sélectionné : avis
   * enregistré avant le filtrage par pays, préférence, avis lié…
   *
   * Le code est ajouté au select pour rester visible, et le contrôle porte l'erreur
   * invalidReferenceValue tant qu'il n'est pas corrigé. La valeur n'est jamais vidée
   * ici : seul un changement de pays la vide.
   */
  private checkNutsValueOfCountry(): void {
    const control = this.localformGroup?.controls.val;
    if (!control) {
      return;
    }
    this.nutsCountryFilterService.addNutsOfCountryValidator(control);

    const value = control.value;
    if (value != null && value !== '' && !this.optionsWithCode?.some(option => option?.code === value)) {
      const nutsOption = this.allNutsOptions.find(option => option?.code === value);
      this.optionsWithCode = [...(this.optionsWithCode || []), nutsOption || {code: value, libelle: value}];
    }

    // Le pays ne fait pas partie du contrôle : la validité est recalculée à chaque passage
    control.updateValueAndValidity({emitEvent: false});
    if (control.errors?.invalidReferenceValue) {
      // Erreur affichée dès l'ouverture de l'avis, sans attendre une saisie
      control.markAsTouched();
    }
  }

  /**
   * Suit le groupe d'adresse du code NUTS, qui contient aussi le pays de l'instance
   * affichée (organisation, UBO, lot, partie, lieu d'exécution). Le contrôle pays peut
   * être créé avant ou après le code NUTS : son ajout comme ses changements font émettre
   * le groupe. Le premier filtrage a pu avoir lieu avant que le groupe ne soit connu.
   */
  private watchNutsCountry(): void {
    this.localformGroup?.parent?.valueChanges
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => this.applyNutsCountryFilter());
    this.applyNutsCountryFilter();
  }

  /**
   * Retourne le code pays associé au champ code NUTS, lu dans le contrôle pays du même
   * groupe d'adresse : chaque organisation, lot ou lieu d'exécution porte son propre pays.
   */
  private getNutsCountryCode(): string {
    return this.nutsCountryFilterService.getCountryCode(this.localformGroup);
  }

  /**
   * Vide le code NUTS dans le formulaire et dans le JSON de l'avis.
   *
   * Le contrôle reçoit une chaîne vide, valeur de l'option vide du select, pour que
   * celui-ci affiche « - Sélectionner - » ; le JSON reçoit null, le champ étant absent.
   */
  private clearNutsValue(): void {
    const control = this.localformGroup?.controls.val;
    if (!control || control.value == null || control.value === '') {
      return;
    }
    control.setValue('');
    this.eformsSubjectService.updateField(
      this.repeatablePathWithIndex, this.field.jsonPath, this.parentForm, 'val', null, this.type, this.field
    );
  }

  /**
   * Indique qu'un chargement de données est en cours : rechargement d'un élément
   * duplicable, d'une préférence ou d'un avis lié.
   */
  private isLoadingAvisData(): boolean {
    return !!(this.eformConditionsV2Service.isReloadingDuplicableElementValue
      || this.eformConditionsV2Service.isLoadingAvisLieValue
      || this.eformConditionsV2Service.isLoadingPreferenceValue);
  }

  onSelectMouseDown(event: MouseEvent) {
    if (this.buttonOtherOption === true) {
      event.preventDefault();
      this.openModalOtherOption();
    }
  }

  openModalOtherOption() {
    const modalRef = this.modalService.open(OtherOptionComponent);
    modalRef.componentInstance.optionsWithCode = this.optionsWithCodeForModal;
    modalRef.componentInstance.valueSelectedOutput
      .subscribe({
        next: (data: any) => {
          const $select = <HTMLInputElement> document.querySelector(`#${this.idFromName.replace('|', '\\|')}`);
          switch (data) {
            case 'EMPTY':
              $select.value = null;
              this.eformsSubjectService.updateField(this.repeatablePathWithIndex, this.field.jsonPath, this.parentForm, 'val', null, this.type, this.field);
              break;

            case null:
              break;

            default:
              $select.value = data.code;
              this.optionsWithCode = [];
              this.optionsWithCode.push(data);
              this.eformsSubjectService.updateField(this.repeatablePathWithIndex, this.field.jsonPath, this.parentForm, 'val', data.code, this.type, this.field);
              this.endOfFocus();
              break;
          }
        }
      });
  }

  specByField() {
    switch (this.field.id) {
      case 'BT-140-notice':
        this.disabled = true;
        break;

      case 'BT-758-notice':
        this.disabled = true;
        break;

      case 'BT-500-Organization-Company':
        this.type = 'textWithStar';
        this.preferenceType = PreferenceType.ACHETEUR;
        break;

      case 'BT-262-Procedure':
        this.type = 'listWithStar';
        this.preferenceType = PreferenceType.CODES_CPV;
        break;

      case 'BT-262-Lot':
        this.type = 'listWithStar';
        this.preferenceType = PreferenceType.CODES_CPV;
        break;

      default:
        break;
    }
  }

  isNotForbidden(elementId: string) {
    let isMandatoryWithCondition = false;
    let val = this.localformGroup?.controls['val']?.value;


    // 🔧 FIX 2026-01-13: Nouvelle logique - d'abord évaluer si interdit, puis si obligatoire
    // Un champ interdit ne peut JAMAIS être obligatoire
    let isFieldForbidden = false;
    let isFieldMandatory = false;

    if (this.isEform) {
      // 1. D'abord vérifier si le champ est interdit (statiquement ou par condition)
      const forbiddenStatic = this.field.forbidden?.includes(this.canNavigateInStepperService.currentFormulaire?.split('E_FORM_')[1]);

      if (forbiddenStatic) {
        isFieldForbidden = true;
      }

      // Nouveau système de conditions
      if (this.canNavigateInStepperService.currentFormulaire) {
        if (Object.values(ConditionsV2EformsEnum).includes(this.canNavigateInStepperService.currentFormulaire as ConditionsV2EformsEnum)) {
          // Vérifier si interdit par condition
          const isForbiddenByCondition = this.eformConditionsV2Service.isFieldForbidden(
            this.field, elementId, this.repeatablePathForDuplicableElement?.getValue()
          ) && !this.isTimeWithFilledSiblingDate();


          if (isForbiddenByCondition) {
            isFieldForbidden = true;
          }

          // Mémoriser l'évaluation de l'interdiction des identifiants de groupes répétables conditionnés.
          // Cette évaluation sera relue par l'extracteur (regenerateNullDuplicableIds) au moment de la sauvegarde.
          this.recordRepeatableGroupForbiddenEvaluation(this.field, isFieldForbidden);

          // 2. Seulement si NON interdit, vérifier si obligatoire
          if (!isFieldForbidden) {
            const mandatoryStatic = this.field.mandatory?.includes(this.canNavigateInStepperService.currentFormulaire?.split('E_FORM_')[1]);
            if (mandatoryStatic) {
              isFieldMandatory = true;
            } else {
              isMandatoryWithCondition = this.eformConditionsV2Service.isFieldMandatory(
                this.field, elementId, this.repeatablePathForDuplicableElement?.getValue()
              );
              if (isMandatoryWithCondition) {
                isFieldMandatory = true;
              }
            }
          }
        }

        // boolean permettant de savoir si on est dans un cas d'avis lié et que les champs sont tous chargés et prêts à être vérifié
        let isAvisLieAndReady = (!this.canNavigateInStepperService.isAvisLieCreate
          || (this.eformDuplicableEntityService.duplicableSectionAvisLieIsCreated.getValue()
            && this.eformDuplicableEntityService.isAvisWithAllDuplicablesElementsReady.getValue()));

        // ⭐ PROTECTION FINALE : Pour les champs partagés (BT-615/BT-15, etc.),
        // ne PAS appliquer les logiques de vidage/initialisation automatiques SAUF lors de la
        // transition visible → caché : à ce moment précis, on vide l'affichage du FormControl.
        //
        // ⚠️ On NE modifie PAS le chemin JSON partagé (pas d'updateField) :
        //    les deux champs écrivent au même endroit JSON — vider le JSON depuis le champ caché
        //    déclencherait un rechargement qui viderait aussi le champ visible (boucle infinie).
        //
        // Le flag est stocké sur `this` (propriété privée du composant) et non sur localformGroup,
        // pour garantir qu'il est strictement par instance de composant.
        if (this.eformSharedFieldsService.isSharedLocationField(this.field?.id)) {
          // _sharedFieldWasForbidden === undefined : première évaluation (chargement), pas de transition
          // _sharedFieldWasForbidden === false     : était visible, maintenant caché → transition
          // _sharedFieldWasForbidden === true      : était déjà caché → rien à faire

          if (isFieldForbidden) {
            // Vider le FormControl partagé UNIQUEMENT quand c'est BT-15-Lot (le champ qui pose
            // la valeur via le préfill) qui devient caché — et seulement sur une vraie transition
            // visible→caché (_sharedFieldWasForbidden === false).
            //
            // BT-615-Lot ne vide JAMAIS : il partage le même FormControl que BT-15-Lot.
            // Si BT-615 vidait lors de sa transition visible→caché, il effacerait la valeur posée
            // par BT-15-Lot (préfill ou saisie), car les deux champs partagent le même FormControl.
            if (this.field?.id === 'BT-15-Lot') {
              const isReloadingShared = (this.eformConditionsV2Service as any).duplicableFieldsService?.isReloadingDuplicableElementValue;
              const isLoadingAvisLieShared = (this.eformConditionsV2Service as any).duplicableFieldsService?.isLoadingAvisLieValue;

              if (this._sharedFieldWasForbidden === false
                && this.eformConditionsV2Service.eformFlatFieldsReady
                && !isReloadingShared
                && !isLoadingAvisLieShared
              ) {
                if (this.localformGroup?.controls['val']) {
                  this.localformGroup.controls['val'].setValue(null, {emitEvent: false});
                }
              }
              this._prefillDocumentUrlApplied = false;
            }

            this._sharedFieldWasForbidden = true;
          } else {
            this._sharedFieldWasForbidden = false;

            // Préfill pour BT-15-Lot si applicable
            if (this.field?.id === 'BT-15-Lot') {
              this.applyPrefillDocumentUrlIfNeeded();
            }
          }

          return !isFieldForbidden;
        }

        // 🔧 FIX 2026-01-21: Ne pas modifier les valeurs pendant le rechargement d'un élément duplicable
        // car les conditions forbidden/mandatory ne sont pas fiables à ce moment-là
        const isReloading = (this.eformConditionsV2Service as any).duplicableFieldsService?.isReloadingDuplicableElementValue;
        // ✅ FIX 2026-03-04: Aussi vérifier isLoadingAvisLie pour éviter le vidage pendant le chargement initial
        const isLoadingAvisLie = (this.eformConditionsV2Service as any).duplicableFieldsService?.isLoadingAvisLieValue;


        if (
          !this.eformDuplicableEntityService.isCreationButBeforeFirstSave.getValue()
          && !sessionStorage.getItem('GR-Lot')
          && !this.eformDuplicableEntityService.needWaitEndUpdateForActiveControls
          && this.eformConditionsV2Service.eformFlatFieldsReady
          && isAvisLieAndReady
          && !isReloading
          && !isLoadingAvisLie  // ✅ FIX 2026-03-04: Ne pas vider pendant le chargement d'un avis
        ) {

          //BT-615-Lot et BT-15-Lot stockent leur valeur au même endroit,
          //ca pose problème si on vide le champ caché car ca vide l'autre en permanence.
          //on vide tout de même si le BT-14-Lot n'est pas remplie
          //Idem pour le BT-615-Part et BT-15-Part

          // 🔧 FIX 2026-01-13: Si le champ est interdit, on doit mettre null
          // et ne JAMAIS entrer dans le bloc mandatory
          // 🔧 FIX 2026-01-21: Utiliser localformGroup ET updateField
          // localformGroup pour l'affichage, updateField pour les données JSON

          if (isFieldForbidden) {
            // Champ interdit : mettre à null
            // 🔧 FIX 2026-01-22: Toujours appeler updateField pour garantir que null est propagé au JSON

            if (this.localformGroup?.controls['val']) {
              this.localformGroup.controls['val'].setValue(null, {emitEvent: false});
            }
            // Toujours propager null au JSON
            this.eformsSubjectService.updateField(this.repeatablePathWithIndex, this.field.jsonPath, this.parentForm, 'val', null, this.type, this.field);
            if (this.field.type.toString() === 'currencyID' && this.localformGroup?.controls['currencyid']) {
              this.localformGroup.controls['currencyid'].setValue(null, {emitEvent: false});
            }
            if (this.field.type.toString() === 'unitCode' && this.localformGroup?.controls['unitcode']) {
              this.localformGroup.controls['unitcode'].setValue(null, {emitEvent: false});
            }
            // Réinitialiser le flag de préfill pour BT-5101(a)-Procedure :
            // quand le champ redevient visible, il devra être prérempli à nouveau
            if (this.field?.id === 'BT-5101(a)-Procedure') {
              (this.localformGroup as any)['_prefillStreetNameApplied'] = false;
            }
            // Réinitialiser le flag de préfill pour BT-18-Lot :
            // quand le champ redevient visible, il devra être prérempli à nouveau
            if (this.field?.id === 'BT-18-Lot') {
              (this.localformGroup as any)['_prefillSubmissionUrlApplied'] = false;
            }
            // NE PAS continuer - le champ est interdit, donc pas de traitement mandatory
          } else if (!isFieldForbidden && (val == null || val === undefined)) {
            // 🔧 FIX 2026-02-11: Quand un champ n'est plus interdit et n'a pas de valeur (null/undefined),
            // appliquer les defaultValue et presetValue UNE SEULE FOIS
            // Cela corrige le problème où BT-09(b)-Procedure n'était pas prérempli
            // car il était temporairement interdit pendant la création de BT-09(a)-Procedure
            // Note: On ne traite PAS val === '' car cela pourrait interférer avec la saisie utilisateur

            // 🔧 FIX 2026-02-11: Ne PAS traiter les champs Unpublish (BT-195, BT-196, BT-197, BT-198)
            // Ces champs doivent rester à null pour être considérés comme "non présents"
            const isUnpublishField = this.field?.id && /^BT-19[5678]\(/.test(this.field.id);
            if (isUnpublishField) {
              // Ne rien faire pour les champs Unpublish - ils doivent rester à null
              return !isFieldForbidden;
            }

            // Vérifier si on a déjà appliqué la defaultValue/presetValue pour ce champ
            const defaultValueAppliedKey = `_defaultValueApplied_${this.field.id}`;
            const hasDefaultValueBeenApplied = (this.localformGroup as any)[defaultValueAppliedKey];

            if (!hasDefaultValueBeenApplied) {
              // Appliquer la presetValue si elle existe
              if (this.field._presetValue) {
                const presetValue = this.field._presetValue === '{NOW}'
                  ? new Date().toISOString().split('T')[0] // Format YYYY-MM-DD
                  : this.field._presetValue;
                if (this.localformGroup?.controls['val']) {
                  this.localformGroup.controls['val'].setValue(presetValue, {emitEvent: false});
                }
                this.eformsSubjectService.updateField(this.repeatablePathWithIndex, this.field.jsonPath, this.parentForm, 'val', presetValue, this.type, this.field);
                // Marquer comme appliqué
                (this.localformGroup as any)[defaultValueAppliedKey] = true;
              }
              // Appliquer la defaultValue si elle existe
              else if (this.field.defaultValue && this.field.defaultValue.length > 0) {
                this.field.defaultValue.forEach(e => {
                  const nameAttribut: string = e.split('=')[0].split('.').pop();
                  let valueAttribut: string = e.split('=').pop().replaceAll('\'', '');

                  // Ne pas appliquer UUID ici, c'est géré ailleurs
                  if (valueAttribut !== 'UUID') {
                    if (valueAttribut.includes('eform-not-editable.')) {
                      valueAttribut = this.translateService.instant(valueAttribut);
                    }
                    if (valueAttribut === 'DATENOW') {
                      valueAttribut = new Date().toISOString().split('T')[0];
                    }
                    if (valueAttribut === 'HOURNOW') {
                      valueAttribut = new Date().toTimeString().split(' ')[0] + '+01:00';
                    }

                    if (this.localformGroup?.controls[nameAttribut]) {
                      this.localformGroup.controls[nameAttribut].setValue(valueAttribut, {emitEvent: false});
                    }
                    this.eformsSubjectService.updateField(this.repeatablePathWithIndex, this.field.jsonPath, this.parentForm, nameAttribut, valueAttribut, this.type, this.field);
                  }
                });
                // Marquer comme appliqué
                (this.localformGroup as any)[defaultValueAppliedKey] = true;
              }
              // Si le champ est obligatoire et n'a pas de defaultValue/presetValue, mettre une chaîne vide
              else if (isFieldMandatory) {
                if (this.localformGroup?.controls['val']) {
                  this.localformGroup.controls['val'].setValue('', {emitEvent: false});
                }
                if (this.field.type.toString() === 'currencyID' && this.localformGroup?.controls['currencyid']) {
                  this.localformGroup.controls['currencyid'].setValue('', {emitEvent: false});
                }
                if (this.field.type.toString() === 'unitCode' && this.localformGroup?.controls['unitcode']) {
                  this.localformGroup.controls['unitcode'].setValue('', {emitEvent: false});
                }
              }
            }
            // Préfill de BT-5101(a)-Procedure depuis prefillValues si la condition de visibilité est vérifiée
            this.applyPrefillStreetNameIfNeeded(elementId);
          } else if (val == null && isFieldMandatory) {
            // Cas original: champ obligatoire avec valeur null (pour compatibilité)
            // 🔧 FIX 2026-02-11: Ne PAS traiter les champs Unpublish (BT-195, BT-196, BT-197, BT-198)
            const isUnpublishFieldHere = this.field?.id && /^BT-19[5678]\(/.test(this.field.id);
            if (!isUnpublishFieldHere) {
              if (this.localformGroup?.controls['val']) {
                this.localformGroup.controls['val'].setValue('', {emitEvent: false});
              }
              if (this.field.type.toString() === 'currencyID' && this.localformGroup?.controls['currencyid']) {
                this.localformGroup.controls['currencyid'].setValue('', {emitEvent: false});
              }
              if (this.field.type.toString() === 'unitCode' && this.localformGroup?.controls['unitcode']) {
                this.localformGroup.controls['unitcode'].setValue('', {emitEvent: false});
              }
            }
          }
          // Préfill de BT-18-Lot depuis prefillValues si la condition de visibilité est vérifiée.
          // Placé hors des blocs val==null/mandatory car BT-18-Lot est mandatory et val vaut "" après
          // initialisation, donc il ne passerait jamais par le bloc val==null.
          if (!isFieldForbidden) {
            this.applyPrefillSubmissionUrlIfNeeded(elementId);
          }
          // Pour les champs OPT avec idScheme : regénérer l'ID si le champ n'est pas interdit (bool !== false)
          // ⚠️ NE PAS générer l'ID pendant le rechargement d'un élément duplicable
          // car les conditions ne sont pas évaluées de manière fiable à ce moment-là
          const isReloadingDuplicable = (this.eformConditionsV2Service as any).isReloadingDuplicableElement?.value;

          // ✅ FIX 2025-12-24: Pour les éléments TEN/CON/TPA, ne régénérer l'ID que si :
          // 1. On n'est pas en train de recharger
          // 2. Le champ n'est vraiment pas interdit
          // 3. La valeur est null ou vide
          // ✅ FIX 2025-01-05: Exception pour le cas "0 lauréat" (clos-nw + no-rece)
          const duplicableIdTypes = ['TEN', 'CON', 'TPA'];
          const isDuplicableIdField = this.field._idScheme && duplicableIdTypes.includes(this.field._idScheme);

          // Pour les champs TEN/CON/TPA, être plus strict :
          // Ne régénérer que si le champ n'est pas interdit
          let shouldRegenerateId = this.field._idScheme && !isReloadingDuplicable;
          shouldRegenerateId = shouldRegenerateId && !isFieldForbidden;

          if (shouldRegenerateId) {
            // Si le champ est null ou vide, générer l'ID
            if (val == null || val === '') {
              let generatedId: string;

              // ✅ FIX 2025-12-24: Pour TEN/CON/TPA, si l'ID était null, c'est forcément XXX-0001
              // car c'est le premier élément de ce type (cas 0 lauréats passant à selec-w)
              if (isDuplicableIdField) {
                generatedId = this.field._idScheme + '-0001';
              } else {
                // Pour les autres types, calculer l'index depuis repeatablePathWithIndex
                let indexForId = '0001';
                if (this.repeatablePathWithIndex && this.repeatablePathWithIndex.includes('_INDEX_')) {
                  const matches = this.repeatablePathWithIndex.match(/_INDEX_(\d+)/g);
                  if (matches && matches.length > 0) {
                    const firstMatch = matches[0];
                    const indexValue = parseInt(firstMatch.replace('_INDEX_', ''), 10);

                    const currentList = this.eformDuplicableEntityService.listDuplicableEntity.getValue();
                    const currentElements = currentList.filter(e => e && e.id && e.id.split('-')[0] === this.field._idScheme);

                    if (currentElements && currentElements[indexValue] && currentElements[indexValue].id) {
                      const realId = currentElements[indexValue].id;
                      indexForId = realId.split('-')[1];
                    } else {
                      indexForId = (indexValue + 1).toString().padStart(4, '0');
                    }
                  }
                }
                generatedId = this.field._idScheme + '-' + indexForId;
              }


              this.eformsSubjectService.updateField(this.repeatablePathWithIndex, this.field.jsonPath, this.parentForm, 'val', generatedId, this.type, this.field);
            }
          }

          if (!isFieldForbidden && val === '' && !isFieldMandatory && !this.field._idScheme) {
            this.eformsSubjectService.updateField(this.repeatablePathWithIndex, this.field.jsonPath, this.parentForm, 'val', null, this.type, this.field);
          }

          if (!isFieldForbidden && (val == null || val === '') && this.field._idScheme) {
            this.eformsSubjectService.updateField(this.repeatablePathWithIndex, this.field.jsonPath, this.parentForm, 'val', this.currentCheckedValue, this.type, this.field);
          }
        }
      }
    }


    return !isFieldForbidden;
  }

  /**
   * Pour le champ BT-5101(a)-Procedure : si la condition de visibilité est satisfaite
   * (BT-5141=FRA AND BT-5071 présent AND BT-5131 présent) et qu'une valeur de préremplissage
   * est présente dans annonce.prefillValues (prefill_streetName), l'injecter dans le champ.
   *
   * Règles :
   * - S'applique une seule fois tant que le champ reste visible (flag _prefillStreetNameApplied)
   * - Si le champ passe forbidden (vidé), le flag est réinitialisé → réapplication au prochain
   *   retour visible
   * - Si l'utilisateur vide le champ manuellement, on ne le rereemplie pas
   */
  private applyPrefillStreetNameIfNeeded(elementId: string): void {
    if (!this.isEform || this.field?.id !== 'BT-5101(a)-Procedure') {
      return;
    }
    const prefillValue = this.avisDataTransferService.avis?.jsonSaisieFormulaire?.prefillValues?.['prefill_streetName'];
    if (!prefillValue) {
      return;
    }
    // Ne réappliquer que si le flag n'a pas encore été positionné (jamais appliqué,
    // ou réinitialisé suite à un passage en forbidden)
    const alreadyApplied = (this.localformGroup as any)['_prefillStreetNameApplied'];
    if (alreadyApplied) {
      return;
    }

    const condition: ConditionGroup = {
      type: 'group',
      operator: ConditionOperator.AND,
      conditions: [
        {type: 'simple', field: 'BT-5141-Procedure', operator: ConditionType.EQUALS, value: 'FRA', isValid: false} as SimpleCondition,
        {type: 'simple', field: 'BT-5071-Procedure', operator: ConditionType.IS_PRESENT, value: null, isValid: false} as SimpleCondition,
        {type: 'simple', field: 'BT-5131-Procedure', operator: ConditionType.IS_PRESENT, value: null, isValid: false} as SimpleCondition,
      ]
    };

    const path = this.repeatablePathForDuplicableElement?.getValue();
    const conditionMet = this.eformConditionsV2Service.evaluateConditions(condition, elementId, path);

    if (conditionMet) {
      if (this.localformGroup?.controls['val']) {
        this.localformGroup.controls['val'].setValue(prefillValue, {emitEvent: false});
      }
      this.eformsSubjectService.updateField(
        this.repeatablePathWithIndex, this.field.jsonPath, this.parentForm, 'val', prefillValue, this.type, this.field
      );
      // Marquer comme appliqué : ne plus rereemplir tant que le champ reste visible
      (this.localformGroup as any)['_prefillStreetNameApplied'] = true;
    }
  }

  /**
   * Pour le champ BT-15-Lot : si la condition (BT-14-Lot == 'non-restricted-document') est satisfaite
   * et qu'une valeur de préremplissage est présente dans annonce.prefillValues (prefill_documentUrl),
   * l'injecter dans le champ.
   *
   * Règles :
   * - S'applique une seule fois tant que le champ reste visible (flag _prefillDocumentUrlApplied)
   * - Si le champ passe forbidden (vidé), le flag est réinitialisé → réapplication au prochain
   *   retour visible
   * - Si l'utilisateur vide le champ manuellement, on ne le rereemplie pas
   */
  private applyPrefillDocumentUrlIfNeeded(): void {
    if (!this.isEform || this.field?.id !== 'BT-15-Lot') {
      return;
    }
    const prefillValue = this.avisDataTransferService.avis?.jsonSaisieFormulaire?.prefillValues?.['prefill_documentUrl'];
    if (!prefillValue) {
      return;
    }
    // Attendre que les flatFields soient prêts pour s'assurer que l'évaluation de la condition
    // est stable. Si on préremplit avant que eformFlatFieldsReady soit true, la condition peut
    // ensuite être réévaluée à 'interdit' et effacer la valeur qu'on vient de poser.
    if (!this.eformConditionsV2Service.eformFlatFieldsReady) {
      return;
    }
    const isReloadingDoc = (this.eformConditionsV2Service as any).duplicableFieldsService?.isReloadingDuplicableElementValue;
    const isLoadingAvisLieDoc = (this.eformConditionsV2Service as any).duplicableFieldsService?.isLoadingAvisLieValue;
    if (isReloadingDoc || isLoadingAvisLieDoc) {
      return;
    }
    // Ne réappliquer que si le flag n'a pas encore été positionné pour ce cycle de visibilité.
    // Le flag est réinitialisé par isNotForbidden à chaque transition caché→visible.
    if (this._prefillDocumentUrlApplied) {
      return;
    }

    // La condition BT-14-Lot == 'non-restricted-document' n'est PAS réévaluée ici.
    // Cette méthode est appelée uniquement depuis la branche non-interdit du bloc shared fields.
    // Le fait que BT-15-Lot soit non-interdit implique déjà que BT-14-Lot == 'non-restricted-document'.
    if (this.localformGroup?.controls['val']) {
      this.localformGroup.controls['val'].setValue(prefillValue, {emitEvent: false});
    }
    this.eformsSubjectService.updateField(
      this.repeatablePathWithIndex, this.field.jsonPath, this.parentForm, 'val', prefillValue, this.type, this.field
    );
    // Marquer comme appliqué pour ne pas écraser la saisie utilisateur pendant ce cycle de visibilité
    this._prefillDocumentUrlApplied = true;
  }

  /**
   * Pour le champ BT-18-Lot : si la condition (BT-17-Lot == 'allowed' OR BT-17-Lot == 'required') est satisfaite
   * et qu'une valeur de préremplissage est présente dans annonce.prefillValues (prefill_submissionUrl),
   * l'injecter dans le champ.
   *
   * Règles :
   * - S'applique une seule fois tant que le champ reste visible (flag _prefillSubmissionUrlApplied)
   * - Si le champ passe forbidden (vidé), le flag est réinitialisé → réapplication au prochain
   *   retour visible
   * - Si l'utilisateur vide le champ manuellement, on ne le rereemplie pas
   */
  private applyPrefillSubmissionUrlIfNeeded(elementId: string): void {
    if (!this.isEform || this.field?.id !== 'BT-18-Lot') {
      return;
    }
    const prefillValue = this.avisDataTransferService.avis?.jsonSaisieFormulaire?.prefillValues?.['prefill_submissionUrl'];
    if (!prefillValue) {
      return;
    }
    // Ne réappliquer que si le flag n'a pas encore été positionné (jamais appliqué,
    // ou réinitialisé suite à un passage en forbidden)
    const alreadyApplied = (this.localformGroup as any)['_prefillSubmissionUrlApplied'];
    if (alreadyApplied) {
      return;
    }

    const condition: ConditionGroup = {
      type: 'group',
      operator: ConditionOperator.OR,
      conditions: [
        {type: 'simple', field: 'BT-17-Lot', operator: ConditionType.EQUALS, value: 'allowed', isValid: false} as SimpleCondition,
        {type: 'simple', field: 'BT-17-Lot', operator: ConditionType.EQUALS, value: 'required', isValid: false} as SimpleCondition,
      ]
    };

    const path = this.repeatablePathForDuplicableElement?.getValue();
    const conditionMet = this.eformConditionsV2Service.evaluateConditions(condition, elementId, path);

    if (conditionMet) {
      if (this.localformGroup?.controls['val']) {
        this.localformGroup.controls['val'].setValue(prefillValue, {emitEvent: false});
      }
      this.eformsSubjectService.updateField(
        this.repeatablePathWithIndex, this.field.jsonPath, this.parentForm, 'val', prefillValue, this.type, this.field
      );
      // Marquer comme appliqué : ne plus rereemplir tant que le champ reste visible
      (this.localformGroup as any)['_prefillSubmissionUrlApplied'] = true;
    }
  }

  tradRules(value, parentForm, repeatablePathWithIndex, prefixId, needCount = false) {
    //trad value
    let conditionSplitted = value.replaceAll('/*/', this.getFormType(parentForm) + '/').split(' ');
    if (conditionSplitted.length == 1) {
      if (needCount) {
        return this.goToField(JSON.parse(JSON.stringify(conditionSplitted[0].replace('!', '').replaceAll('/&', '&').replaceAll('(', '').replaceAll(')', ''))), parentForm, repeatablePathWithIndex, prefixId, true)?.length;
      }
      let field = this.goToField(JSON.parse(JSON.stringify(conditionSplitted[0].replace('!', '').replaceAll('/&', '&').replaceAll('(', '').replaceAll(')', ''))), parentForm, repeatablePathWithIndex, prefixId);
      // is present or not present simple
      if (conditionSplitted[0].startsWith('!') || conditionSplitted[0].startsWith('(!')) {
        return (field == undefined || field == null || field == '' || field == 'null');
      } else {
        return (field != undefined && field != null && field != '' && field != 'null');
      }
    } else {

      let strTrad = JSON.parse(JSON.stringify(value)).replaceAll('!(', '(!').replaceAll('/*/', this.getFormType(parentForm) + '/');

      while (strTrad.includes('(')) {
        let cut = strTrad.substring(strTrad.indexOf('(') + 1);
        let countBracket: number = 0;
        let endBracket: number;
        for (let index = 0; index < cut.length; index++) {
          const element = cut[index];
          if (element === ')') {
            if (countBracket === 0) {
              endBracket = JSON.parse(JSON.stringify(index));
              break;
            } else {
              countBracket--;
            }
          }
          if (element === '(') {
            countBracket++;
          }
        }
        let firstgrp = cut.substring(0, endBracket);
        const startWithCount = strTrad.startsWith('count');
        strTrad = strTrad.replace('(' + firstgrp + ')', this.tradRules(firstgrp, parentForm, repeatablePathWithIndex, prefixId, startWithCount));
        if (startWithCount) {
          strTrad = strTrad.replace('count', '');
        }
      }

      let strTradSplit = strTrad.split(' ');

      while (strTradSplit.length >= 3) {
        let firstValue = strTradSplit[0];
        let operator = strTradSplit[1];
        let secondValue = strTradSplit[2];

        strTradSplit.shift();
        strTradSplit.shift();


        let valueIsNot = false;
        let fieldIsNot = false;

        if (secondValue && (secondValue.toString().startsWith('!') || secondValue.toString().startsWith('(!'))) {
          valueIsNot = true;
        }
        if (firstValue && (firstValue.toString().startsWith('!') || firstValue.toString().startsWith('(!'))) {
          fieldIsNot = true;
        }

        strTradSplit[0] = this.doConditions(operator, secondValue, firstValue, fieldIsNot, valueIsNot, parentForm, repeatablePathWithIndex, prefixId, needCount);

      }
      if (strTradSplit[0] === 'true') {
        strTradSplit[0] = true;
      }
      if (strTradSplit[0] === 'false') {
        strTradSplit[0] = false;
      }
      return strTradSplit[0];
    }
  }

  doConditions(operator, values, fieldValue, fieldIsNot, valueIsNot, parentForm, repeatablePathWithIndex, prefixId, needArray = false) {
    values = this.getFieldOrValue(values, parentForm, repeatablePathWithIndex, prefixId);
    if (Array.isArray(values)) {
      values = values.map(element => {
        return element?.toLowerCase().replaceAll('\'', '');
      });
    } else {
      values = values?.toString().toLowerCase().replaceAll('\'', '');
      if (values?.includes('{') && values?.includes(',')) {
        values = values.replaceAll('{', '').replaceAll('}', '').split(',');
      }
    }
    needArray = (operator === 'in' || operator === '!in') ? true : needArray;
    if (this.field?.id == 'OPT-321-Tender' || this.field?.id == 'OPT-316-Contract') {
      //Ajout specifique car la condition de ce champ devrait être un in au lieu d'une egalié
      needArray = true;
    }
    fieldValue = this.getFieldOrValue(fieldValue, parentForm, repeatablePathWithIndex, prefixId, needArray);

    if (Array.isArray(fieldValue)) {
      fieldValue = fieldValue?.map(element => {
        return element?.toLowerCase();
      });
    } else {
      if (fieldValue != null) {
        fieldValue = fieldValue?.toString().toLowerCase();
      } else {
        fieldValue = '';
      }
    }
    let booleanReturned: boolean;
    switch (operator) {
      case ('in'): {
        booleanReturned = fieldValue?.lastIndexOf(values) != -1 && fieldValue?.lastIndexOf(values) != undefined || values?.lastIndexOf(fieldValue[0]) != -1 && values?.lastIndexOf(fieldValue[0]) != undefined;
        break;
      }
      case ('!in'): {
        booleanReturned = fieldValue?.lastIndexOf(values) == -1 && values?.lastIndexOf(fieldValue[0]) == -1;
        break;
      }
      case ('=='): {
        booleanReturned = (Array.isArray(fieldValue) ? fieldValue?.lastIndexOf(values) != -1 : values == fieldValue);
        break;
      }
      case ('!='): {
        booleanReturned = (Array.isArray(fieldValue) ? fieldValue?.lastIndexOf(values) == -1 : values != fieldValue);
        break;
      }
      case ('>'): {
        booleanReturned = ((Array.isArray(fieldValue)) ? fieldValue?.length : fieldValue) > ((Array.isArray(values) ? values[0] : values));
        break;
      }
      case ('>='): {
        booleanReturned = ((Array.isArray(fieldValue)) ? fieldValue?.length : fieldValue) >= ((Array.isArray(values) ? values[0] : values));
        break;
      }
      case ('<'): {
        booleanReturned = ((Array.isArray(fieldValue)) ? fieldValue?.length : fieldValue) < ((Array.isArray(values) ? values[0] : values));
        break;
      }
      case ('<='): {
        booleanReturned = ((Array.isArray(fieldValue)) ? fieldValue?.length : fieldValue) <= ((Array.isArray(values) ? values[0] : values));
        break;
      }
      case ('&&'): {
        let currentValue = this.getFieldOrValue(values, parentForm, repeatablePathWithIndex, prefixId);
        return this.getCorrectCondition(fieldValue, fieldIsNot) && this.getCorrectCondition(currentValue, valueIsNot);
      }
      case ('||'): {
        let currentValue = this.getFieldOrValue(values, parentForm, repeatablePathWithIndex, prefixId);
        return this.getCorrectCondition(fieldValue, fieldIsNot) || this.getCorrectCondition(currentValue, valueIsNot);
      }
      default: {
        break;
      }
    }
    return fieldIsNot == false ? booleanReturned : !booleanReturned;
  }

  getFieldOrValue(values, parentForm, repeatablePathWithIndex, prefixId, needArray = false) {
    let currentValue;
    if (Array.isArray(values)) {
      currentValue = values[0];
    } else {
      currentValue = values;
    }

    if (currentValue && (currentValue.toString().toLowerCase().includes('contractawardnotice/') ||
      currentValue.toString().toLowerCase().includes('priorinformationnotice/') ||
      currentValue.toString().toLowerCase().includes('businessregistrationinformationnotice/') ||
      currentValue.toString().toLowerCase().includes('contractnotice/'))) {
      return this.goToField(JSON.parse(JSON.stringify(currentValue)).replace('!', '').replaceAll('/&', '&').replaceAll('(', '').replaceAll(')', ''), parentForm, repeatablePathWithIndex, prefixId, needArray);
    } else {
      return currentValue;
    }
  }

  getCorrectCondition(value, isNot) {
    if (value && value.toString().startsWith('!')) {
      value = value.toString().replace('!', '');
    }
    value = (value != undefined && value != null && value != 'false' && value != '' && value != 'null');
    if (isNot) {
      return !value;
    } else {
      return value;
    }
  }

  cleanValueFromBracket(value) {
    return value.replaceAll('{', '').replaceAll('}', '').replaceAll('(', '').replaceAll(')', '').replaceAll('\'', '');
  }

  getFormType(parentForm) {
    if (parentForm?.priorinformationnotice !== null) {
      return 'priorinformationnotice';
    }
    if (parentForm?.contractnotice !== null) {
      return 'contractnotice';
    }
    if (parentForm?.contractawardnotice !== null) {
      return 'contractawardnotice';
    }
    if (parentForm?.businessregistrationinformationnotice !== null) {
      return 'businessregistrationinformationnotice';
    }
  }

  goToField(value, parentForm, repeatablePathWithIndex, prefixId, needArray = false) {
    let prefixIdNumbers = prefixId.substring(prefixId.search(prefixId) + 1).split('_');
    const pathElements = JSON.parse(JSON.stringify(value)).toLowerCase().replaceAll('/text', '&val').split('/');

    let arrayValues = this.searchValuesRecursively(pathElements, 0, repeatablePathWithIndex, prefixIdNumbers, parentForm, needArray);

    return needArray ? arrayValues : (arrayValues?.length > 0 ? arrayValues[0] : null);
  }

  searchValuesRecursively(pathElements, indexElement, repeatablePathWithIndex, prefixIdNumbers, p, needArray) {
    let arrayValues = [];
    const q = pathElements[indexElement];
    //check listname etc..
    if (p == null || p == undefined) {
      return null;
    }
    if (pathElements.length === indexElement) {
      arrayValues.push(p?.val);
      return arrayValues;
    }
    let temp = null;
    if (q.includes('[')) {
      //scheme/listname
      let valueSplitted = q.split('[');
      let attributes = this.getAttributes(valueSplitted[1]);
      let actualGroup = p[valueSplitted[0]];
      if (attributes.champ != '' && Array.isArray(actualGroup)) {
        let pFiltered = actualGroup.filter(u => {
          if (u[attributes.champ]) {
            if (!Array.isArray(u[attributes.champ])) {
              return u[attributes.champ.toLowerCase()][attributes.attribute.toLowerCase()]?.toLowerCase() === attributes.attributeValue.toLowerCase();
            } else {
              return u[attributes.champ.toLowerCase()][0][attributes.attribute.toLowerCase()]?.toLowerCase() === attributes.attributeValue.toLowerCase();
            }
          }
        });
        if (pFiltered.length == 1) {
          temp = pFiltered[0];
        } else if (pFiltered.length > 1) {
          temp = pFiltered[prefixIdNumbers.length != 0 && prefixIdNumbers.length > 2 ? prefixIdNumbers[1] : 0];
          return this.searchValuesRecursively(pathElements, JSON.parse(JSON.stringify(indexElement)) + 1, repeatablePathWithIndex, prefixIdNumbers, temp, needArray);
        }
      } else {
        if (actualGroup != null) {
          temp = actualGroup[attributes.attribute.toLowerCase()]?.toLowerCase() == attributes.attributeValue.toLowerCase() ? actualGroup : null;
        } else {
          temp = null;
        }
      }
    } else {
      temp = p ? p[q] : null;
      if (Array.isArray(temp)) {
        if (prefixIdNumbers[0] === 'R-Lot' && q === 'procurementprojectlot') {
          temp = temp[prefixIdNumbers[1]];
        } else if (needArray) {
          for (const t of temp) {
            const arraytmp = this.searchValuesRecursively(pathElements, JSON.parse(JSON.stringify(indexElement)) + 1, repeatablePathWithIndex, prefixIdNumbers, t, needArray);
            if (arraytmp?.length) {
              for (const iterator of arraytmp) {
                arrayValues.push(iterator);
              }
            }
          }
          return arrayValues;
        } else {
          const matchsubCondition = this.subConditions.filter(item => item.word === q);
          if (matchsubCondition.length > 0) {
            temp = temp[this.eformConditionService.findIndexWithSubCondition(matchsubCondition, p[q])];
          } else {
            temp = temp[this.getIndexAfterArray(repeatablePathWithIndex, q)] ?? temp[0];
          }
        }
      }
    }
    if (pathElements.length - 1 === indexElement) {
      arrayValues.push(temp?.val);
      return arrayValues;
    } else {
      return this.searchValuesRecursively(pathElements, JSON.parse(JSON.stringify(indexElement)) + 1, repeatablePathWithIndex, prefixIdNumbers, temp, needArray);
    }
  }

  getIndexAfterArray(path: string, arrayName: string): number | null {
    const regex = new RegExp(`${arrayName}\\[\\](\\d+)`);
    const match = path.match(regex);

    return match ? parseInt(match[1], 10) : 0;
  }

  getAttributes(value) {
    let champ = value.substring(0, value.indexOf('&'));
    let attribute = value.substring(value.indexOf('&') + 1, value.indexOf('=')).replace('name', 'Name');
    let attributeValue = value.substring(value.indexOf('=') + 2, value.length - 2);
    return {champ: champ, attribute: attribute, attributeValue: attributeValue};
  }

  isParcoursUtilisateur() {
    if (this.isEform && this.field.parcoursUtilisateur) {
      let currentCible = this.eformInfoService.mapCurrentJsonForm.get(this.field.parcoursUtilisateur['cible']);
      return this.eformDataService.getArray(this.field, this.parentForm, this.repeatablePathWithIndex, currentCible.jsonPath, currentCible.object, this.noticeValue, true, this.eformConditionService) == 0;
    }
    return false;
  }

  addOrgName() {
    this.eformDynamicListService.setOrganizationName(this.parentForm, this.eformDuplicableEntityService.listDuplicableEntity.getValue().filter(e => e.id.includes('ORG')));
    this.eformDynamicListService.getOrganizationName().subscribe((value) => {
      for (let i = 0; i < value.length; i++) {
        if (this.optionsWithCode[i + 1]?.code) {
          if (value[i]) {
            this.optionsWithCode[i + 1].libelle = this.optionsWithCode[i + 1]?.code + ' - Organisation - ' + value[i];
          } else {
            this.optionsWithCode[i + 1].libelle = this.optionsWithCode[i + 1]?.code + ' - Organisation';
          }
        }
      }
    });
  }

  addTendererName() {
    this.eformDynamicListService.setTendererName(this.parentForm, this.eformDuplicableEntityService.listDuplicableEntity.getValue().filter(e => e.id.includes('TPA')));
    this.eformDynamicListService.getTendererName().subscribe((value) => {
      for (let i = 0; i < value.length; i++) {
        if (this.optionsWithCode[i + 1]?.code) {
          if (value[i]) {
            this.optionsWithCode[i + 1].libelle = this.optionsWithCode[i + 1]?.code + ' - Soumissionnaire - ' + value[i];
          } else {
            this.optionsWithCode[i + 1].libelle = this.optionsWithCode[i + 1]?.code + ' - Soumissionnaire';
          }
        }
      }
    });
  }

  addOfferName() {
    this.eformDynamicListService.setOfferName(this.parentForm, this.eformDuplicableEntityService.listDuplicableEntity.getValue().filter(e => e.id.includes('TEN')));
    this.eformDynamicListService.getOfferName().subscribe((value) => {
      for (let i = 0; i < value.length; i++) {
        if (this.optionsWithCode[i + 1]?.code) {
          if (value[i]) {
            this.optionsWithCode[i + 1].libelle = this.optionsWithCode[i + 1]?.code + ' - Offre - ' + value[i];
          } else {
            this.optionsWithCode[i + 1].libelle = this.optionsWithCode[i + 1]?.code + ' - Offre';
          }
        }
      }
    });
  }

  /**
   * Re-cliquer sur le bouton déjà coché le décoche (troisième état), SAUF si le champ est
   * obligatoire : un radio 'required' doit toujours rester coché sur l'une de ses valeurs.
   *
   * PRB0052504 : cette restriction est volontairement globale et s'applique donc à tous les
   * groupes de radios porteurs d'une règle 'required' dans l'application, pas seulement aux
   * critères sociaux / environnementaux.
   */
  private checkRadioButton(radioButton) {
    if (this.currentCheckedValue === radioButton.value && !this.isRequired()) {
      radioButton.checked = false;
      this.ren.removeClass(radioButton['_elementRef'].nativeElement, 'cdk-focused');
      this.ren.removeClass(radioButton['_elementRef'].nativeElement, 'cdk-program-focused');
      this.currentCheckedValue = null;
      this.localformGroup.controls[this.name].setValue(null);
      setTimeout(() => {
        radioButton.checked = false;
      });
    } else {
      this.currentCheckedValue = radioButton.value;
      this.localformGroup.controls[this.name].setValue(this.currentCheckedValue);
    }
    // ✅ FIX NG0100: Utiliser markForCheck au lieu de detectChanges
    this.cd.markForCheck();
  }

  private isValidDate(dateString: string): boolean {
    // Controle pour les dates qui sont au format YYYY-MM-DD
    if (dateString.length === 10) {
      const dateFinDiffusionPattern = /^\d{4}-\d{2}-\d{2}$/;
      if (dateFinDiffusionPattern.test(dateString)) {
        return true;
      }
    }

    const datePattern = /^\d{4}-\d{2}-\d{2}[T\s]\d{2}:\d{2}(:\d{2})?$/;
    if (!datePattern.test(dateString)) {
      return false; // Le format est incorrect
    }

    // Remplacer l'espace par "T" pour uniformiser le format
    dateString = dateString.replace(' ', 'T');

    const [datePart, timePart] = dateString.split('T');
    const [year, month, day] = datePart.split('-').map(Number);
    const timeParts = timePart.split(':').map(Number);
    const hours = timeParts[0];
    const minutes = timeParts[1];
    const seconds = timeParts.length === 3 ? timeParts[2] : 0;

    const date = new Date(year, month - 1, day, hours, minutes, seconds);

    return (
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day &&
      date.getHours() === hours &&
      date.getMinutes() === minutes &&
      date.getSeconds() === seconds
    );
  }

  private updateIndexForDuplicableObjects(formInput: FormInput) {
    // Vérifications de sécurité
    if (!formInput || !formInput.sepSep || !this.idFromName || !this.subSectionId) {
      return;
    }

    if (Object.keys(DuplicableElementSubSectionIdEnum).includes(this.subSectionId as DuplicableElementSubSectionIdEnum)) {
      const elementId = this.getElementIdFromPrefixId();
      if (!elementId) {
        return;
      }

      const parts = elementId.split('_');
      if (parts.length >= 2) {
        const indexPart = parseInt(parts[1], 10);
        if (!isNaN(indexPart) && this.idFromName.includes(formInput.sepSep)) {
          this.idFromName = this.idFromName.replace(formInput.sepSep, `_${indexPart}${formInput.sepSep}`);
        }
      }
    }
  }

  /**
   * Enregistre, pour les identifiants de groupes répétables disposant d'une condition dynamique d'interdiction,
   * l'évaluation du critère forbidden dans une map partagée.
   * L'extracteur la relira au save pour décider s'il régénère ou non l'identifiant technique.
   * @param field champ à traiter (vérification si le champ est un identifiant avec une condition d'interdiction)
   * @param isFieldForbidden évaluation du statut d'interdiction à stocker
   */
  private recordRepeatableGroupForbiddenEvaluation(field: Field, isFieldForbidden: boolean): void {
    const groupType = this.getRepeatableGroupIdentifierType(field);
    if (!groupType) {
      return;
    }
    const groupIndex = this.eformConditionsV2Service.getDisplayedRealIndex(groupType);
    if (groupIndex === undefined || groupIndex < 0) {
      return;
    }
    this.eformConditionsV2Service.setRepeatableGroupForbidden(groupType, groupIndex, isFieldForbidden);
  }

  /**
   * Indique si ce champ est une heure (ex : BT-131(t)-Lot) interdite uniquement en l'absence de sa date
   * (BT-131(d)-Lot), alors que cette date est bien renseignée dans le formulaire.
   *
   * PRB0050792 : la condition « date absente » est évaluée sur les flatFields, qui peuvent ne pas encore
   * contenir la date du lot qui vient d'être chargé (navigateur lent). L'heure était alors jugée interdite,
   * vidée dans le contrôle et dans le JSON, puis enregistrée vide au changement de lot. Le contrôle de la
   * date, voisin de celui de l'heure dans le même groupe, reflète lui la donnée chargée et fait donc foi.
   */
  private isTimeWithFilledSiblingDate(): boolean {
    if (this.field?.type !== 'time') {
      return false;
    }
    const dateFieldId = this.field.id?.replace('(t)', '(d)');
    const conditions = this.field.forbiddenConditionV2?.conditions;
    if (dateFieldId === this.field.id || conditions?.length !== 1) {
      return false;
    }
    const condition = conditions[0] as SimpleCondition;
    if (condition.type !== 'simple' || condition.operator !== ConditionType.IS_NOT_PRESENT || condition.field !== dateFieldId) {
      return false;
    }
    // jsonPath : '...tendersubmissiondeadlineperiod.endtime.val' → contrôle voisin 'enddate.val'
    const pathSegments = this.field.jsonPath?.split('.') ?? [];
    const timeKey = pathSegments[pathSegments.length - 2];
    if (!timeKey?.endsWith('time')) {
      return false;
    }
    const dateValue = this.localformGroup?.parent?.get([timeKey.replace(/time$/, 'date'), 'val'])?.value;
    return dateValue !== null && dateValue !== undefined && dateValue !== '';
  }

  /**
   * Récupère le type d'identifiants de groupes répétables disposant d'une condition d'interdiction dynamique
   * @param field element à tester et pour lequel récupérer le préfixe de clé identifiant le type de groupe
   * @private
   */
  private getRepeatableGroupIdentifierType(field: Field): string | null {
    if (EmptyValueHelper.isEmptyStringValue(field?._idScheme) ||
      !field?.forbiddenConditionV2) {
      return null;
    }
    return field._idScheme;
  }

  /**
   * Extrait l'ID de l'élément duplicable depuis le prefixId
   */
  private getElementIdFromPrefixId(): string {
    if (!this.prefixId) {
      return 'UNK_0';
    }
    return this.prefixId;
  }

  /**
   * Extrait le type d'élément duplicable depuis l'elementId
   */
  private getTypeFromElementId(elementId: string): string {
    if (!elementId) {
      return 'UNK';
    }

    const parts = elementId.split('_');
    if (parts.length === 0) {
      return 'UNK';
    }

    const firstPart = parts[0];

    // Vérifier si c'est un type connu
    if (firstPart.startsWith('GR-')) {
      const grType = firstPart.substring(3);
      if (grType === 'Lot') {
        return 'LOT';
      }
      if (grType === 'Part') {
        return 'PAR';
      }
      return grType;
    }

    if (firstPart.startsWith('R-')) {
      return firstPart.substring(2);
    }

    return 'UNK';
  }

  /**
   * Filtre les options d'autocomplétion
   */
  private filter(value: any): any[] {
    if (!this.autoCompleteService || this.autoCompleteType === undefined) {
      return [];
    }

    const filterValue = typeof value === 'string' ? value.toLowerCase() : '';

    let options: any[] = [];

    // Convertir la chaîne en valeur d'enum si nécessaire
    const acTypeStr = typeof this.autoCompleteType === 'string' ? this.autoCompleteType : AutoCompleteType[this.autoCompleteType];

    switch (acTypeStr) {
      case 'CPV':
      case AutoCompleteType[AutoCompleteType.CPV]:
        this.autoCompleteService.cpv$.pipe(take(1)).subscribe(cpv => options = cpv);
        break;
      case 'MOT_CLEF':
      case AutoCompleteType[AutoCompleteType.MOT_CLEF]:
        this.autoCompleteService.motClef$.pipe(take(1)).subscribe(motClef => options = motClef);
        break;
      case 'CODENUTS':
      case AutoCompleteType[AutoCompleteType.CODENUTS]:
      case 'LIEUCODENUTS':
      case AutoCompleteType[AutoCompleteType.LIEUCODENUTS]:
        this.autoCompleteService.nuts$.pipe(take(1)).subscribe(nuts => options = nuts);
        break;
      case 'PAYS':
      case AutoCompleteType[AutoCompleteType.PAYS]:
        this.autoCompleteService.countries$.pipe(take(1)).subscribe(countries => options = countries);
        break;
      case 'LANGEC':
      case AutoCompleteType[AutoCompleteType.LANGEC]:
        // Utiliser la liste statique avec codes à 2 lettres pour les formulaires BOAMP/MAPA
        // au lieu de language$ qui contient les codes à 3 lettres de la BDD
        if (!this.isEform) {
          options = this.autoCompleteService.getOptions('LANGEC');
        } else {
          this.autoCompleteService.language$.pipe(take(1)).subscribe(language => options = language);
        }
        break;
      case 'CURRENCY':
      case AutoCompleteType[AutoCompleteType.CURRENCY]:
      case 'DEVISE':
      case AutoCompleteType[AutoCompleteType.DEVISE]:
        this.autoCompleteService.currency$.pipe(take(1)).subscribe(currency => options = currency);
        break;
      case 'DURATIONUNIT':
      case AutoCompleteType[AutoCompleteType.DURATIONUNIT]:
        this.autoCompleteService.durationUnit$.pipe(take(1)).subscribe(durationUnit => options = durationUnit);
        break;
      case 'MEASUREMENTUNIT':
      case AutoCompleteType[AutoCompleteType.MEASUREMENTUNIT]:
        this.autoCompleteService.measurementUnit$.pipe(take(1)).subscribe(measurementUnit => options = measurementUnit);
        break;
      case 'RAPPEL':
      case AutoCompleteType[AutoCompleteType.RAPPEL]:
        options = this.autoCompleteService.getOptions('RAPPEL') || [];
        break;
      default:
        return [];
    }

    // CPV : filtrer sur le code qui COMMENCE par la valeur
    if (acTypeStr === 'CPV' || acTypeStr === AutoCompleteType[AutoCompleteType.CPV]) {
      return options.filter(option =>
        option.code?.toLowerCase().startsWith(filterValue)
      );
    }

    // Autres : filtrer sur le code ET libellé qui CONTIENT la valeur
    return options.filter(option =>
      option.code?.toLowerCase().includes(filterValue) ||
      option.libelle?.toLowerCase().includes(filterValue)
    );
  }

  /**
   * Extrait le timestamp d'une date
   */
  private getTimestamp(dateString: string): string {
    if (!dateString || dateString === this.DATE_FORMAT || dateString === this.DATETIME_FORMAT) {
      return '';
    }

    // Si la date contient un timestamp
    if (dateString.includes('T') || dateString.includes(' ')) {
      const parts = dateString.split(/[T ]/);
      if (parts.length > 1) {
        return parts[1];
      }
    }

    return '';
  }

  /**
   * Convertit une date au format attendu
   */
  private convertDate(dateString: string): string {
    if (!dateString) {
      return this.DATE_FORMAT;
    }

    // Si c'est déjà au bon format
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      return dateString;
    }

    // Si c'est un format datetime, extraire juste la date
    if (dateString.includes('T') || dateString.includes(' ')) {
      const parts = dateString.split(/[T ]/);
      return parts[0];
    }

    return dateString;
  }

  /**
   * Extrait l'heure (HH:mm:ss) à partir d'une valeur ISO complète (ex: préremplissage
   * backend "2024-09-16T17:30:00.000+02:00"), symétrique à convertDate() pour la date.
   * Sans cette extraction, l'input HTML natif type="time" rejette silencieusement
   * toute valeur qui n'est pas strictement au format HH:mm ou HH:mm:ss.
   */
  private convertTime(timeString: string): string {
    if (!timeString) {
      return '';
    }

    // Si c'est déjà au bon format HH:mm ou HH:mm:ss
    if (/^\d{2}:\d{2}(:\d{2})?$/.test(timeString)) {
      return timeString;
    }

    // Si c'est un format datetime, extraire la partie heure (sans millisecondes ni décalage horaire)
    const match = timeString.match(/T(\d{2}:\d{2}:\d{2})/);
    if (match) {
      return match[1];
    }

    return timeString;
  }

}
